const NewWaitingListAssessment = (() => {
  //--------------------------
  // SESSION DATA
  //--------------------------
  let isNewAssessment = true;
  let selectedConsumer;
  let wlLinkID;
  let wlDocuments;
  let wlParticipants;
  let SFAccountId;
  let WLInfoID;
  let nextTempParticipantId = -1;
  let nextTempNeedId = -1;
  let wlNeeds = {};
  let editMode = false;
  let AssessmentId;
  let finalizeResult;
  //--------------------------
  // DOM
  //--------------------------
  let assessmentWrap;
  let tableOfContents;
  let contributingCircumstancesWrap;
  let needsWrap;
  let tocLinks;
  let doucmentsList;
  //--------------------------
  // UI INSTANCES
  //--------------------------
  let backButton;
  let consumerCard;
  let wlForms;
  let participantsTable;
  let sendEmailButton;
  let sendEmailPopup;
  let sendEmailForm;
  let documentsButton;
  let finalizeBtn;
  let finalizePopupBtn;
  let documentsForm;
  let documentsPopup;
  let nextQuestionButton;
  let getConclusionButton;
  let currentQuestionId;
  const questionMap = {};
  let nextTempHousemateId = -1;
  let wlHousemates = {};
  let nextTempCommunityId = -1;
  let wlCommunityBasedNeeds = {};
  let nextTempIndividualId = -1;
  let wlIndividualNeeds = {};
  let nextTempResourcesId = -1;
  let wlResourcesUsed = {};
  let nextTempCountyBoardId = -1;
  let wlCountyBoardContacts = {};
  let housematesTable, housematesForm;
  let _wlSpinner = null;
  const countyBoardOwners = {
    approvalStatus: false,
    waiverRequirement: false,
  };

  const sections = {
    waitingListInfo: {
      name: 'Waiting List Information',
      dbtable: 'WLA_Waiting_List_Information',
      enabled: true,
      formElements: [
        {
          id: 'interviewDate',
          type: 'date',
          label: 'Interview Date',
          required: true,
        },
        {
          id: 'personCompleting',
          label: 'Name of person completing assessment',
          type: 'text',
          required: true,
        },
        {
          id: 'personCompletingTitle',
          label: 'Title of person completing assessment',
          type: 'text',
          required: true,
        },
        {
          type: 'text',
          id: 'conclusionDeterminedBy',
          label: 'Name of person determining conclusion:',
          required: true,
        },
        {
          type: 'text',
          id: 'conclusionDeterminedByTitle',
          label: 'Title of person determining conclusion:',
          required: true,
        },
        {
          id: 'conclusionDeterminedOn',
          type: 'date',
          label: 'Date conclusion determined:',
        },
        {
          id: 'areasPersonNeedsHelp',
          label: 'In what areas does person report needing help?',
          fullscreen: true,
          type: 'textarea',
          required: true,
        },
        {
          id: 'currentLivingArrangement',
          label: 'Describe the current living arrangement',
          type: 'select',
          required: true,
          data: [
            { value: '', text: '' },
            { value: 'Lives Alone', text: 'Lives Alone' },
            {
              value: 'Lives with One Or More Other Persons In A Private Residence',
              text: 'Lives with One Or More Other Persons In A Private Residence',
            },
            {
              value: 'Lives in an Intermediate Care Facility for Individuals with Intellectual Disabilities (ICFIID)',
              text: 'Lives in an Intermediate Care Facility for Individuals with Intellectual Disabilities (ICFIID)',
            },
            { value: 'Lives in Nursing Facility', text: 'Lives in Nursing Facility' },
            { value: 'Other', text: 'Other' },
          ],
        },
        {
          id: 'livingArrangementOther',
          label: 'Describe Other Living Arrangement',
          fullscreen: true,
          type: 'textarea',
          disabled: true,
          required: true,
        },
      ],
    },
    housemates: {
      name: 'Housemates',
      enabled: false,
    },
    participants: {
      name: 'Participants',
      enabled: true,
    },
    currentAvailableServices: {
      name: 'Current/Available Services',
      dbtable: 'WLA_Active_Services',
      enabled: false,
      formElements: [
        {
          type: 'radiogroup',
          id: 'isCountyBoardFunding',
          groupLabel: 'County Board services / funding',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isCountyBoardFundingyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isCountyBoardFundingno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isOhioEarlyInterventionService',
          groupLabel: 'Help Me Grow / Ohio Early Intervention',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isOhioEarlyInterventionServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isOhioEarlyInterventionServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isBCMHService',
          groupLabel: 'Bureau for Children with Medical Handicaps',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isBCMHServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isBCMHServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isFCFCService',
          groupLabel: 'Family and Children First Council',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isFCFCServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isFCFCServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isODEService',
          groupLabel: 'Ohio Department of Education',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isODEServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isODEServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isOODService',
          groupLabel: 'Vocational Rehabilitation / Opportunities for Ohioans with Disabilities',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isOODServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isOODServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isChildrenServices',
          groupLabel: 'Children Services',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isChildrenServicesyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isChildrenServicesno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidStatePlanHomeHealthAideservice',
          groupLabel: 'Medicaid Managed Care Plan State Plan Home Health Aide',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidStatePlanHomeHealthAideserviceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidStatePlanHomeHealthAideserviceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidStatePlanHomeHealthNursingService',
          groupLabel: 'Medicaid Managed Care Plan State Plan Home Health Nursing',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidStatePlanHomeHealthNursingServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidStatePlanHomeHealthNursingServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidStatePlanService',
          groupLabel: 'Medicaid Managed Care Plan State Plan Private Duty Nursing',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidStatePlanServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidStatePlanServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isOhioHomeCareWaiverservice',
          groupLabel: 'Ohio Home Care Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isOhioHomeCareWaiverserviceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isOhioHomeCareWaiverserviceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isPassportWaiverService',
          groupLabel: 'PASSPORT Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isPassportWaiverServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isPassportWaiverServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isAssistedLivingWaiverService',
          groupLabel: 'Assisted Living Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isAssistedLivingWaiverServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isAssistedLivingWaiverServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMYCarewaiverService',
          groupLabel: 'MyCare Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMYCarewaiverServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMYCarewaiverServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isSelfWaiverService',
          groupLabel: 'Medicaid Managed Care Plan Self-Empowered Life Funding Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isSelfWaiverServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isSelfWaiverServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isLevelOneWaiverService',
          groupLabel: 'Medicaid Managed Care Plan Level One Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isLevelOneWaiverServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isLevelOneWaiverServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidFeeForOhioRiseCaseManagement',
          groupLabel: 'Medicaid Fee for Service OhioRISE Case Management',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidFeeForOhioRiseCaseManagementyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidFeeForOhioRiseCaseManagementno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidFeeForOhioRiseOther',
          groupLabel: 'Medicaid Fee for Service OhioRise Other Service',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidFeeForOhioRiseOtheryes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidFeeForOhioRiseOtherno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidFeeForisMedicaidStatePlanHomeHealthAideservice',
          groupLabel: 'Medicaid Fee for Service Medicaid State Plan Home Health Aide',
          required: true,
          fields: [
            {
              type: 'radio',
              label: 'Yes',
              value: 'yes',
              id: 'isMedicaidFeeForisMedicaidStatePlanHomeHealthAideserviceyes',
            },
            {
              type: 'radio',
              label: 'No',
              value: 'no',
              id: 'isMedicaidFeeForisMedicaidStatePlanHomeHealthAideserviceno',
            },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidFeeForMedicaidStatePlanHomeHealthNursingService',
          groupLabel: 'Medicaid Fee for Service Medicaid State Plan Home Health Nursing',
          required: true,
          fields: [
            {
              type: 'radio',
              label: 'Yes',
              value: 'yes',
              id: 'isMedicaidFeeForMedicaidStatePlanHomeHealthNursingServiceyes',
            },
            {
              type: 'radio',
              label: 'No',
              value: 'no',
              id: 'isMedicaidFeeForMedicaidStatePlanHomeHealthNursingServiceno',
            },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidFeeForMedicaidStatePlanService',
          groupLabel: 'Medicaid Fee for Service Medicaid State Plan Private Duty Nursing',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidFeeForMedicaidStatePlanServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidFeeForMedicaidStatePlanServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidFeeForSelfWaiverService',
          groupLabel: 'Medicaid Fee for Service Self-Empowered Life Funding Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidFeeForSelfWaiverServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidFeeForSelfWaiverServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isMedicaidFeeForLevelOneWaiverService',
          groupLabel: 'Medicaid Fee for Service Level One Waiver',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isMedicaidFeeForLevelOneWaiverServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isMedicaidFeeForLevelOneWaiverServiceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isOhioRiseCaseManagement',
          groupLabel: 'Medicaid Managed Care Plan OhioRISE Case Management',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isOhioRiseCaseManagementyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isOhioRiseCaseManagementno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isOhioRiseOther',
          groupLabel: 'Medicaid Managed Care Plan OhioRISE Other Service',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isOhioRiseOtheryes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isOhioRiseOtherno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isPrivateInsurance',
          groupLabel: 'Private Insurance',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isPrivateInsuranceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isPrivateInsuranceno' },
          ],
        },
        {
          type: 'radiogroup',
          id: 'isOtherService',
          groupLabel: 'Other Medical Managed Care Plan',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isOtherServiceyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isOtherServiceno' },
          ],
        },
        {
          label: 'Other Medical Managed Care Plan:',
          id: 'otherDescription',
          fullscreen: true,
          type: 'textarea',
          disabled: true,
          required: true,
        },
      ],
    },
  };

  const conlusionSection = {
    conclusion: {
      name: 'Conclusion',
      enabled: true,
      formElements: [
        {
          type: 'checkboxgroup',
          id: 'conclusions',
          groupLabel:
            'The options below are selected automatically based on answers provided throughout the assessment.',
          disabled: true,
          fields: [
            {
              type: 'checkbox',
              label:
                'Individual does not require waiver enrollment or placement on the Waiting List for Home and Community-Based Services because there is no identified need.',
              id: 'conclusionUnmetNeeds',
            },
            {
              type: 'checkbox',
              label:
                'The individual does not require waiver enrollment or placement on the Waiting List for Home and Community-Based Services as alternative services are available to meet the assessed need.',
              id: 'conclusionWaiverFunded12Months',
            },
            {
              type: 'checkbox',
              label:
                'The individual has unmet needs that require enrollment in a waiver at this time to address circumstances presenting an immediate risk of harm.',
              id: 'conclusionDoesNotRequireWaiver',
            },
            {
              type: 'checkbox',
              label:
                'The individual has needs that are likely to require waiver-funded supports within the next 12 months and will be placed on the Waiting List for Home and Community-Based Services at this time.',
              id: 'conclusionNotEligibleForWaiver',
            },
          ],
        },
      ],
    },
  };

  const approvalSectionAlternateResources = {
    approval: {
      name: 'Approval',
      enabled: true,
      formElements: [
        {
          id: 'approvalStatus',
          label: 'Approval Status',
          type: 'select',
          required: true,
          data: [
            { value: '', text: '' },
            { value: 'Approved', text: 'Approved' },
            { value: 'Not Approved', text: 'Not Approved' },
          ],
        },
        {
          id: 'reasonForDisapproval',
          label: 'Reason For Disapproval',
          type: 'text',
          required: true,
        },
      ],
    },
    countyBoardInfo: {
      name: 'County Board Info',
      enabled: true,
    },
    assessedNeeds: {
      name: 'Assessed Needs',
      enabled: true,
    },
  };

  const CurrentNeedsorImmediateNeeds = {
    approval: {
      name: 'Approval',
      enabled: true,
      formElements: [
        {
          type: 'radiogroup',
          id: 'waiverRequirement',
          label:
            'Will the unmet need require enrollment in a waiver due to the lack of community based alternative services to address the need?',
          groupLabel: 'Will the unmet need require enrollment in a waiver due to the lack of community based alternative services to address the need?',
          required: true,
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'isWaiverRequiredyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'isWaiverRequiredno' },
          ],
        },
        {
          id: 'unmetNeed',
          label: 'Unmet Need',
          type: 'textarea',
          required: true,
        },
      ],
    },
    communityBasedAssessedNeeds: {
      name: 'Community Based Assessed Needs',
    },
    IndividualAssessedNeeds: {
      name: 'Current Assessed Needs',
      enabled: true,
    },
    countyBoardInfo: {
      name: 'County Board Info',
      enabled: true,
    },
    approvalCont: {
      name: 'Approval Continued',
      enabled: true,
      formElements: [
        {
          id: 'approvalStatus',
          label: 'Approval Status',
          type: 'select',
          required: true,
          data: [
            { value: '', text: '' },
            { value: 'Approved', text: 'Approved' },
            { value: 'Not Approved', text: 'Not Approved' },
          ],
        },
        {
          id: 'reasonForDisapproval',
          label: 'Reason For Disapproval',
          type: 'select',
          required: true,
          data: [
            { value: 'Alternative resources', text: 'Alternative resources' },
            { value: 'Re-Assessment', text: 'Re-Assessment' },
          ],
        },
      ],
    },
    immediateAssessedNeeds: {
      name: 'Immediate Assessed Needs',
      enabled: true,
    },
  };

  const initialSections = structuredClone(sections);

  // UTILS
  //--------------------------------------------------
  async function unload() {
    selectedConsumer = undefined;
    wlLinkID = undefined;
    wlCircID = undefined;
    wlNeedID = undefined;
    wlDocuments = undefined;
    wlParticipants = undefined;
    wlData = undefined;
    isNewAssessment = undefined;
  }
  function addNewDocumentToList({ documentId, fileName }) {
    const documentItem = _DOM.createElement('p', { class: 'docList__Item', text: fileName });
    const deleteIcon = Icon.getIcon('delete');
    documentItem.appendChild(deleteIcon);

    documentItem.addEventListener('click', async e => {
      if (e.target === deleteIcon) {
        await _UTIL.fetchData('deleteSupportingDocument', { attachmentId: documentId });
        return;
      }

      var form = document.createElement('form');
      form.setAttribute(
        'action',
        `${$.webServer.protocol}://${$.webServer.address}:${$.webServer.port}/${$.webServer.serviceName}/viewWaitingListAttachment/`,
      );
      form.setAttribute('method', 'POST');
      form.setAttribute('target', '_blank');
      form.setAttribute('enctype', 'application/json');
      form.setAttribute('success', () => {});
      var tokenInput = document.createElement('input');
      tokenInput.setAttribute('name', 'token');
      tokenInput.setAttribute('value', $.session.Token);
      tokenInput.id = 'token';
      var attachmentInput = document.createElement('input');
      attachmentInput.setAttribute('name', 'attachmentId');
      attachmentInput.setAttribute('value', documentId);
      attachmentInput.id = 'attachmentId';

      form.appendChild(tokenInput);
      form.appendChild(attachmentInput);
      form.style.position = 'absolute';
      form.style.opacity = '0';
      document.body.appendChild(form);

      form.submit();
    });

    doucmentsList.appendChild(documentItem);
  }
  function toggleSendEmailDisabledStatus() {
    // refactor to use the new variable isAssessmentComplete
    const incompleteSections = Object.values(tocLinks).filter(link => {
      return (
        !link.classList.contains('hiddenPage') &&
        !link.classList.contains('formComplete') &&
        !link.classList.contains('parent')
      );
    });

    if (!$.session.waitingListUpdate) {
      sendEmailButton.toggleDisabled(true);
      return;
    }

    sendEmailButton.toggleDisabled(incompleteSections.length > 0 && !$.session.sendWaitingListEmail);
  }

  function addQuestionOrSection(questionJSON) {
    const fullName = questionJSON.SectionName;
    // everything after the last “–” (dash + space)
    const displayName = fullName.replace(/^.*?-\s*/, '');
    const sectionId = fullName.replace(/\s+/g, '_').toLowerCase();

    // determine question type and build field config
    const questionType = (questionJSON.DataType || '').toLowerCase();
    let formElement = {
      id: questionJSON.Name,
      label: questionJSON.QuestionText,
      required: questionJSON.Required,
      questionJSON: questionJSON,
    };

    switch (questionType) {
      case 'radio':
        formElement.type = 'radiogroup';
        formElement.groupLabel = questionJSON.QuestionText;
        formElement.name = questionJSON.Name;
        formElement.fields = questionJSON.ResponseValues.map((val, idx) => ({
          id: `${questionJSON.Name}_${idx}`,
          label: val,
          name: questionJSON.Name,
          value: val,
        }));
        break;

      case 'select':
        formElement.type = 'select';
        formElement.data = questionJSON.ResponseValues.map(val => ({ value: val, text: val }));
        break;

      case 'checkbox':
        formElement.type = 'checkbox';
        break;

      case 'textarea':
        formElement.type = 'textarea';
        formElement.fullscreen = true;
        break;

      case 'multiselect':
        formElement.type = 'checkboxgroup';
        formElement.groupLabel = questionJSON.QuestionText;
        formElement.fields = questionJSON.ResponseValues.map((val, idx) => ({
          id: `${questionJSON.Name}_${idx}`,
          label: val.trim(),
          value: val.trim(),
        }));
        break;

      default:
        formElement.type = 'text';
        formElement.placeholder = questionJSON.Placeholder || '';
        formElement.minLength = questionJSON.MinLength || '';
        formElement.maxLength = questionJSON.MaxLength || '';
        break;
    }

    // ─── New section? ───
    if (!sections[sectionId]) {
      // initialize section model with this first field
      sections[sectionId] = {
        name: fullName,
        enabled: true,
        formElements: [formElement],
      };

      // TOC Entry
      const tocSection = _DOM.createElement('p', { class: ['section', sectionId] });
      const tocSectionLink = _DOM.createElement('a', { href: `#${sectionId}`, text: displayName });
      //const statusIcon = Icon.getIcon('error');
      tocSection.appendChild(tocSectionLink);
      //tocSection.appendChild(statusIcon);
      tableOfContents.appendChild(tocSection);
      tocLinks[sectionId] = tocSection;

      // Section Wrap + Header
      const sectionWrap = _DOM.createElement('div', { id: sectionId, class: 'wlPage' });
      const sectionHeader = _DOM.createElement('h2', { text: displayName });
      sectionWrap.appendChild(sectionHeader);
      assessmentWrap.appendChild(sectionWrap);

      // instantiate Form with the single field
      wlForms[sectionId] = new Form({
        hideAllButtons: true,
        fields: sections[sectionId].formElements,
        formName: sectionId,
        waitingListFlag: true
      });
      wlForms[sectionId].renderTo(sectionWrap);
      wlForms[sectionId].onChange(onFormChange);
    }

    // ─── Existing section: append just the new question ───
    else {
      // update model
      sections[sectionId].formElements.push(formElement);
      wlForms[sectionId].options.fields.push(formElement);

      // build one input instance (mirroring Form._build)
      const ft = formElement.type.toLowerCase();
      let inputInstance;

      switch (ft) {
        case 'radiogroup':
          inputInstance = new RadioGroup({ ...formElement });
          break;
        case 'checkbox':
          inputInstance = new Checkbox({ ...formElement });
          break;
        case 'checkboxgroup':
          inputInstance = new CheckboxGroup({ ...formElement });
          break;
        case 'select': {
          const sel = { ...formElement };
          delete sel.type;
          inputInstance = new Select(sel);
          break;
        }
        case 'textarea': {
          const ta = { ...formElement };
          delete ta.type;
          inputInstance = new Textarea(ta);
          break;
        }
        case 'attachment': {
          const att = { ...formElement };
          delete att.type;
          inputInstance = new Attachments(att);
          break;
        }
        default:
          inputInstance = new Input({ ...formElement });
      }

      if (typeof wlForms[sectionId].options.onChange === 'function') {
        inputInstance.onChange(wlForms[sectionId].options.onChange);
      }

      // append to existing <form> element
      wlForms[sectionId].form.appendChild(inputInstance.rootElement);

      // stash input instance for population & change
      if (ft === 'checkboxgroup') {
        wlForms[sectionId].inputs = {
          ...wlForms[sectionId].inputs,
          ...inputInstance.inputs,
        };
      } else {
        wlForms[sectionId].inputs[formElement.id] = inputInstance;
      }
    }

    // track current question
    currentQuestionId = questionJSON.Name;

    // store in map
    questionMap[questionJSON.Name] = {
      json: { ...questionJSON, response: undefined },
      form: wlForms[sectionId],
      section: sectionId,
    };

    // ─── pre-fill if we already have a response ───
    if (questionJSON.Response != null) {
      const inst = wlForms[sectionId];
      const rawResp = questionJSON.Response;
      const isArray = Array.isArray(rawResp);

      // CASE A: a true multi-select field
      if (questionType === 'multiselect') {
        // ensure we have an array of selected values
        const selections = isArray ? rawResp : [rawResp];
        selections.forEach(val => {
          // find index in your ResponseValues to map to the checkbox id
          const idx = questionJSON.ResponseValues.findIndex(rv => rv.trim() === String(val).trim());
          if (idx < 0) return;
          // each option’s input was created with id `${Name}_${idx}`
          const checkbox = inst.inputs[`${questionJSON.Name}_${idx}`];
          if (checkbox) checkbox.setValue(true);
        });
      }
      // CASE B: everything else (radio, select, single checkbox, text, etc.)
      else {
        // if the API gave an array for non-multi, just pick the first
        const respVal = (isArray ? rawResp?.[0] : rawResp) ?? '';

        switch (questionType) {
          case 'radio': {
            const idx = questionJSON.ResponseValues.indexOf(respVal);
            if (idx > -1) {
              inst.inputs[questionJSON.Name].setValue(`${questionJSON.Name}_${idx}`);
            }
            break;
          }
          case 'select':
            inst.inputs[questionJSON.Name].setValue(respVal);
            break;
          case 'checkbox':
            inst.inputs[questionJSON.Name].setValue(!!respVal);
            break;
          default:
            inst.inputs[questionJSON.Name].setValue(respVal);
            break;
        }
      }
    }

    // scroll to the new field or section
    const scrollTarget =
      wlForms[sectionId].form.querySelector(`[name="${questionJSON.Name}"]`) || document.getElementById(sectionId);
    scrollTarget.scrollIntoView({ behavior: 'smooth' });
  }

  function buildErrorPopupText(payload) {
    const result = payload;
    const err = result.ErrorMessage || {};
    const lines = [];

    // 1) Always include the top‐level message if present
    if (err.Message) {
      lines.push(err.Message.trim());
    }

    // 2) If there’s a nested ErrorMessage.ResourcesServices array, show those Values
    if (err.ErrorMessage && Array.isArray(err.ErrorMessage.ResourcesServices)) {
      err.ErrorMessage.ResourcesServices.forEach(item => {
        if (item.Value) lines.push(item.Value.trim());
      });

      // 3) Otherwise, if there’s an Assessments array, show those entries
    } else if (Array.isArray(err.Assessments)) {
      err.Assessments.forEach(a => {
        lines.push(a.trim());
      });
    } else {
      return payload;
    }

    return lines.join('\n');
  }

  function updateNextQuestionButton() {
    const allAnswered = Object.entries(sections).every(([sectionId, cfg]) => {
      if (!cfg.formElements) return true; // no form here

      return cfg.formElements.every(fe => {
        if (!fe.required) return true; // only enforce required

        // 1) Detect disabled via DOM (works for text, date, textarea, select, and radio/checkbox groups)
        const byName = Array.from(document.getElementsByName(fe.id));
        if (byName.length) {
          // radio/checkbox group: if *all* inputs for this name are disabled, skip it
          if (byName.every(el => el.disabled)) return true;
        } else {
          const single = document.getElementById(fe.id);
          if (single && single.disabled) return true;
        }

        // 2) Otherwise, pull the current value from the Form API
        const inputComp = wlForms[sectionId].inputs[fe.id];
        if (!inputComp) return true; // not rendered yet?
        const val = inputComp.getValue();

        // consider non-empty / non-false answers as “answered”
        return val !== '' && val != null && val !== false;
      });
    });

    nextQuestionButton.toggleDisabled(!allAnswered);
  }

  function setCountyBoardEnabled(owner, enable) {
  // override to awlays show the county board grid with the immediate need and current need result
  const waiverOverride = owner === 'waiverRequirement' && (finalizeResult === 'Immediate Need' || finalizeResult === 'Current Need');

  countyBoardOwners[owner] = waiverOverride ? true : !!enable;

  const countyBoardSection = document.getElementById('countyBoardInfo');
  if (!countyBoardSection) return;

  // Visible if ANY owner wants it enabled
  const shouldShow = countyBoardOwners.approvalStatus || countyBoardOwners.waiverRequirement;

  countyBoardSection.classList.toggle('hiddenPage', !shouldShow);

  if (sections?.countyBoardInfo) sections.countyBoardInfo.enabled = shouldShow;
  if (tocLinks?.countyBoardInfo) tocLinks.countyBoardInfo.classList.toggle('hiddenPage', !shouldShow);
}

   function setCountyBoardEnabled(owner, enable) {
    // override to awlays show the county board grid with the immediate need and current need result
    const waiverOverride = owner === 'waiverRequirement' && (finalizeResult === 'Immediate Need' || finalizeResult === 'Current Need');

    countyBoardOwners[owner] = waiverOverride ? true : !!enable;

    const countyBoardSection = document.getElementById('countyBoardInfo');
    if (!countyBoardSection) return;

    // Visible if ANY owner wants it enabled
    const shouldShow = countyBoardOwners.approvalStatus || countyBoardOwners.waiverRequirement;

    countyBoardSection.classList.toggle('hiddenPage', !shouldShow);

    if (sections?.countyBoardInfo) sections.countyBoardInfo.enabled = shouldShow;
    if (tocLinks?.countyBoardInfo) tocLinks.countyBoardInfo.classList.toggle('hiddenPage', !shouldShow);
  }
  
  /**
 * Disable any form question (fieldset) that has at least one answered control.
 */
function disableAnsweredQuestions() {
  // loop through each form instance
  Object.values(wlForms).forEach(form => {
    Object.entries(form.inputs).forEach(([fieldId, inputComp]) => {
      const val = inputComp.getValue();
      // for checkboxes/radios getValue might be boolean, for multis select an array, for text a string
      const isAnswered = 
        (typeof val === 'boolean' && val) ||
        (Array.isArray(val) && val.length > 0) ||
        (typeof val === 'string' && val.trim() !== '');
      
      if (!isAnswered) return;

      const byName = document.getElementsByName(fieldId);
      if (byName.length) {
        byName.forEach(el => el.disabled = true);
      } else {
        const single = document.getElementById(fieldId);
        if (single) single.disabled = true;
      }

      // now find and disable the containing <fieldset>
      let anchor = document.getElementById(fieldId) || byName[0];
      if (anchor) {
        const fs = anchor.closest('fieldset');
        if (fs) fs.disabled = true;
      }
    });
  });
}

function showErrorPopup(headerText, errorText) {
  try {
    hideSpinner();
  } catch {
    // do nothing
  }
  
  // show popup with the error message
  const errorPopup = POPUP.build({
    header: headerText,
    modal: true,
    hideX: true,
  });

  const cancelBtn = button.build({
    type: 'button',
    style: 'secondary',
    text: 'Cancel',
    type: 'contained',
    callback: () => {
      POPUP.hide(errorPopup);

      const popupBg = document.querySelector('.popup__background');
      if (popupBg) {
        popupBg.remove(); // this will completely remove the div from the DOM
      }
    },
  });

  const msgParagraph = document.createElement('p');
  const popupText = buildErrorPopupText(errorText);
  msgParagraph.innerHTML = popupText;

  errorPopup.appendChild(msgParagraph);
  errorPopup.appendChild(cancelBtn);

  POPUP.show(errorPopup);
}

async function handleIsNewAssessmentFlow() {
  
        showSpinner('Initializing Assessment');

        // Collect answered values in participants and waiting list information
        const answeredValues = collectAnsweredValuesInfoAndParticipants();

        // Make original POST to initialize assessement
        const response = await _UTIL.fetchData('WLAInitializeAssessment', {
          SFAccountId: SFAccountId,
          consumerId: selectedConsumer.id,
          interviewDate: answeredValues.interviewDate,
          interviewer: answeredValues.personCompleting,
          interviewerTitle: answeredValues.personCompletingTitle,
          currentLivingArrangement: answeredValues.currentLivingArrangement,
          livingArrangementOther: answeredValues.livingArrangementOther,
          participants: answeredValues.participants,
          areasPersonNeedsHelp: answeredValues.areasPersonNeedsHelp,
          conclusionDeterminedBy: answeredValues.conclusionDeterminedBy,
          conclusionDeterminedByTitle: answeredValues.conclusionDeterminedByTitle,
          conclusionDate: answeredValues.conclusionDeterminedOn,
          isAssistedLivingWaiverService: answeredValues.isAssistedLivingWaiverService,
          isBCMHService: answeredValues.isBCMHService,
          isChildrenServices: answeredValues.isChildrenServices,
          isCountyBoardFunding: answeredValues.isCountyBoardFunding,
          isFCFCService: answeredValues.isFCFCService,
          isLevelOneWaiverService: answeredValues.isLevelOneWaiverService,
          isMYCarewaiverService: answeredValues.isMYCarewaiverService,
          isMedicaidStatePlanHomeHealthAideservice: answeredValues.isMedicaidStatePlanHomeHealthAideservice,
          isMedicaidStatePlanHomeHealthNursingService: answeredValues.isMedicaidStatePlanHomeHealthNursingService,
          isMedicaidStatePlanService: answeredValues.isMedicaidStatePlanService,
          isODEService: answeredValues.isODEService,
          isOODService: answeredValues.isOODService,
          isOhioEarlyInterventionService: answeredValues.isOhioEarlyInterventionService,
          isOhioHomeCareWaiverservice: answeredValues.isOhioHomeCareWaiverservice,
          isOtherService: answeredValues.isOtherService,
          isPassportWaiverService: answeredValues.isPassportWaiverService,
          isSelfWaiverService: answeredValues.isSelfWaiverService,
          isMedicaidFeeForOhioRiseCaseManagement: answeredValues.isMedicaidFeeForOhioRiseCaseManagement,
          isMedicaidFeeForOhioRiseOther: answeredValues.isMedicaidFeeForOhioRiseOther,
          isMedicaidFeeForisMedicaidStatePlanHomeHealthAideservice:
            answeredValues.isMedicaidFeeForisMedicaidStatePlanHomeHealthAideservice,
          isMedicaidFeeForMedicaidStatePlanHomeHealthNursingService:
            answeredValues.isMedicaidFeeForMedicaidStatePlanHomeHealthNursingService,
          isMedicaidFeeForMedicaidStatePlanService: answeredValues.isMedicaidFeeForMedicaidStatePlanService,
          isMedicaidFeeForSelfWaiverService: answeredValues.isMedicaidFeeForSelfWaiverService,
          isMedicaidFeeForLevelOneWaiverService: answeredValues.isMedicaidFeeForLevelOneWaiverService,
          isOhioRiseCaseManagement: answeredValues.isOhioRiseCaseManagement,
          isOhioRiseOther: answeredValues.isOhioRiseOther,
          isPrivateInsurance: answeredValues.isPrivateInsurance,
          otherDescription: answeredValues.otherDescription,
          housemates: answeredValues.housemates,
        });

        const getNextQuestion = response.WLAInitializeAssessmentResult;
        let getNextQuestionSucess;
        if (getNextQuestion.Success === true) {
          const response2 = await _UTIL.fetchData('WLAGetNextQuestion', {
            token: $.session.Token,
            SFAccountId: SFAccountId,
            AssessmentId: getNextQuestion.AssessmentId,
            WLInfoID: getNextQuestion.WLInfoID,
            consumerId: selectedConsumer.id,
          });
          getNextQuestionSucess = response2.WLAGetNextQuestionResult;

          if (getNextQuestionSucess.Success === true) {
            isNewAssessment = false;
            WLInfoID = getNextQuestionSucess.WLInfoID;
            AssessmentId = getNextQuestionSucess.AssessmentId;
            addQuestionOrSection(getNextQuestionSucess);
            editAssessmentButton.renderTo(assessmentWrap);
          } else {
            hideSpinner();
            // show popup with the error message
            const errorPopup = POPUP.build({
              header: 'Initialization Failed',
              modal: true,
              hideX: true,
            });

            const cancelBtn = button.build({
              type: 'button',
              style: 'secondary',
              text: 'Cancel',
              type: 'contained',
              callback: () => {
                POPUP.hide(errorPopup);

                const popupBg = document.querySelector('.popup__background');
                if (popupBg) {
                  popupBg.remove(); // this will completely remove the div from the DOM
                }
              },
            });

            const msgParagraph = document.createElement('p');
            const popupText = buildErrorPopupText(getNextQuestionSucess);
            msgParagraph.innerHTML = popupText;

            errorPopup.appendChild(msgParagraph);
            errorPopup.appendChild(cancelBtn);

            POPUP.show(errorPopup);
            return;
          }
        } else {
          showErrorPopup('Initialization Failed', getNextQuestion);
          return;
        }

        hideSpinner();

        // Show the green checkmark popup
        successfulSave.show('Assessment Initialized Successfully');
        setTimeout(() => {
          successfulSave.hide();
        }, 1000);

        editMode = false;
      disableAnsweredQuestions();
}

async function handleGetNextQuestionFlow() {
  let entry;
        let payload;
        let response;

  const answeredValues = collectAnsweredValues();
          entry = questionMap[currentQuestionId];
          if (!entry) throw new Error('No active question!');

          entry.json.Response = answeredValues;
          payload = entry.json;

          response = await _UTIL.fetchData('WLAPostResponse', {
            token: $.session.Token,
            SFAccountId,
            questionJSON: payload,
            consumerId: selectedConsumer.id,
            WLInfoID,
          });

          if (response.WLAPostResponseResult.Success !== true) {
            hideSpinner();

            // show popup with the error message
            const errorPopup = POPUP.build({
              header: 'Post Response Failed',
              modal: true,
              hideX: true,
            });

            const cancelBtn = button.build({
              type: 'button',
              style: 'secondary',
              text: 'Cancel',
              type: 'contained',
              callback: () => {
                POPUP.hide(errorPopup);

                const popupBg = document.querySelector('.popup__background');
                if (popupBg) {
                  popupBg.remove(); // this will completely remove the div from the DOM
                }
              },
            });

            const msgParagraph = document.createElement('p');
            const popupText = buildErrorPopupText(response.WLAPostResponseResult.Message);
            msgParagraph.innerHTML = popupText;

            errorPopup.appendChild(msgParagraph);
            errorPopup.appendChild(cancelBtn);

            POPUP.show(errorPopup);
            return;
          } else if (
            response?.WLAPostResponseResult?.NextQuestion?.ErrorMessage?.Message === 'No Next Question' ||
            response?.WLAPostResponseResult?.NextQuestion?.Message === 'No Next Question'
          ) {
            hideSpinner();

            // show popup with the error message
            const errorPopup = POPUP.build({
              header: 'Assessment Complete!',
              modal: false,
              hideX: true,
            });

            let finalizeLaterBtn = new Button({
              text: 'Finalize Later',
              style: 'Secondary',
              styleType: 'contained',
              class: ['btn', 'btn--secondary']
            });

            finalizeLaterBtn.onClick(() => {
              POPUP.hide(errorPopup);

                const popupBg = document.querySelector('.popup__background');
                if (popupBg) {
                  popupBg.remove(); // this will completely remove the div from the DOM
                }
            });

            const msgParagraph = document.createElement('p');
            const popupText = 'No Next Question, Assessment Is Complete';
            msgParagraph.innerHTML = popupText;

            const buttonWrapper =  document.createElement('div');

            buttonWrapper.style.cssText = 'margin-top: 5px; display: flex; justify-content: center; gap: 15px;';

            errorPopup.appendChild(msgParagraph);
            errorPopup.appendChild(buttonWrapper);
            finalizePopupBtn.renderTo(buttonWrapper);
            finalizeLaterBtn.renderTo(buttonWrapper);

            POPUP.show(errorPopup);
            return;
          }

          const nextQuestion = response.WLAPostResponseResult.NextQuestion;
          nextQuestion.AssessmentId = response.WLAPostResponseResult.AssessmentId;
          addQuestionOrSection(nextQuestion);
          hideSpinner();

           editMode = false;
      disableAnsweredQuestions();
}

async function handleEditModeNextQuestionFlow() {
  let entry;
        let payload;
        let response; 
  entry = questionMap[currentQuestionId];
          if (!entry) throw new Error('No active question!');

          // Get just this question’s answer
          const raw = entry.form.inputs[currentQuestionId].getValue(undefined, true);
          entry.json.Response = Array.isArray(raw) ? raw : [raw];

          // Determine if this is the last question on the page
          const fieldsets = Array.from(assessmentWrap.querySelectorAll('fieldset'));
          const currentIndex = fieldsets.findIndex(fs => fs.querySelector(`[name="${currentQuestionId}"]`));

          payload = entry.json;

          response = await _UTIL.fetchData('WLAPostEditResponse', {
            token: $.session.Token,
            SFAccountId,
            questionJSON: payload,
            consumerId: selectedConsumer.id,
            WLInfoID,
          });

          if (response.WLAPostEditResponseResult === 'Success') {
            // Remove every <fieldset> after the one with our currentQuestionId
            const fsets = assessmentWrap.querySelectorAll('fieldset');
            let found = false;
            fsets.forEach(fs => {
              if (found) fs.remove();
              else if (fs.querySelector(`[name="${currentQuestionId}"]`)) found = true;
            });

            // Remove every section wrapper (.wlPage) after the current one
            const pages = Array.from(assessmentWrap.querySelectorAll('.wlPage'));
            found = false;
            pages.forEach(page => {
              if (found) page.remove();
              else if (page.querySelector(`[name="${currentQuestionId}"]`)) found = true;
            });

            // figure out which section we’re in now
            const currentSectionId = questionMap[currentQuestionId].section;
            // get the ordered list of all section keys
            const allKeys = Object.keys(sections);
            // find where our current section sits
            const currentIndex = allKeys.indexOf(currentSectionId);

            if (currentIndex > -1) {
              // every section after currentIndex should be deleted
              const toRemove = allKeys.slice(currentIndex + 1);
              toRemove.forEach(secId => {
                delete sections[secId];
              });
            }

            // Wait for 2 seconds before fetching the next question to allow DODD to update (otherwise issues arise)
            await new Promise(resolve => setTimeout(resolve, 2000));

            const response2 = await _UTIL.fetchData('WLAGetNextQuestion', {
              token: $.session.Token,
              SFAccountId: SFAccountId,
              AssessmentId: AssessmentId,
              WLInfoID: WLInfoID,
              consumerId: selectedConsumer.id,
            });
            getNextQuestionSucess = response2.WLAGetNextQuestionResult;

            if (getNextQuestionSucess.Success === true) {
              if (getNextQuestionSucess.Message === 'No Next Question') {
                hideSpinner();

              // show popup with the error message
              const errorPopup = POPUP.build({
                header: 'Assessment Complete!',
                modal: false,
                hideX: true,
              });

              let finalizeLaterBtn = new Button({
                text: 'Finalize Later',
                style: 'Secondary',
                styleType: 'contained',
                class: ['btn', 'btn--secondary']
              });

              finalizeLaterBtn.onClick(() => {
                POPUP.hide(errorPopup);

                  const popupBg = document.querySelector('.popup__background');
                  if (popupBg) {
                    popupBg.remove(); // this will completely remove the div from the DOM
                  }
              });

              const msgParagraph = document.createElement('p');
              const popupText = 'No Next Question, Assessment Is Complete';
              msgParagraph.innerHTML = popupText;

              const buttonWrapper =  document.createElement('div');

              buttonWrapper.style.cssText = 'margin-top: 5px; display: flex; justify-content: center; gap: 15px;';

              errorPopup.appendChild(msgParagraph);
              errorPopup.appendChild(buttonWrapper);
              finalizePopupBtn.renderTo(buttonWrapper);
              finalizeLaterBtn.renderTo(buttonWrapper);

              POPUP.show(errorPopup);
              return;
              }

              isNewAssessment = false;
              WLInfoID = getNextQuestionSucess.WLInfoID;
              addQuestionOrSection(getNextQuestionSucess);
              hideSpinner();
            } else {
              showErrorPopup('Initialization Failed', getNextQuestionSucess)
              return;
            }
          }

          editMode = false;
      disableAnsweredQuestions();
}


  /**
   * Returns an object of { fieldId: value } for every form input
   * whose underlying DOM element is not disabled and has a non-empty value.
   */
  function collectAnsweredValues() {
    const answers = {};

    Object.values(wlForms).forEach(form => {
      Object.entries(form.inputs).forEach(([fieldId, inputComp]) => {
        // find the DOM node(s)
        const domEls = document.getElementsByName(fieldId).length
          ? Array.from(document.getElementsByName(fieldId))
          : [document.getElementById(fieldId)].filter(Boolean);

        if (!domEls.length || domEls.some(el => el.disabled)) return;

        // get the “raw” API value
        let val = inputComp.getValue(undefined, true);

        // if it came back boolean true, it’s almost certainly a checkbox —
        // so grab its .value instead of “true”
        const firstEl = domEls[0];
        if (firstEl.type === 'checkbox' && val === true) {
          val = firstEl.value;
        }

        if (val !== '' && val != null && val !== false) {
          answers[fieldId] = val;
        }
      });
    });

    return Object.values(answers);
  }

  function resetSections() {
    // remove all current keys from sections
    Object.keys(sections).forEach(k => delete sections[k]);
    // copy back in the originals
    Object.assign(sections, structuredClone(initialSections));

    // now clear out any stale entries in questionMap
    Object.keys(questionMap).forEach(k => delete questionMap[k]);

    // if you’re tracking the “current” question, reset that too
    currentQuestionId = undefined;

    // Clear out all “grid” data
    wlNeeds = {};
    wlCommunityBasedNeeds = {};
    wlIndividualNeeds = {};
    wlResourcesUsed = {};
    wlCountyBoardContacts = {};
    wlParticipants = {};
    wlHousemates = {};
    wlDocuments = {};

    // Reset all your temp‐ID counters
    nextTempNeedId = -1;
    nextTempCommunityId = -1;
    nextTempIndividualId = -1;
    nextTempResourcesId = -1;
    nextTempCountyBoardId = -1;
    nextTempHousemateId = -1;
    nextTempParticipantId = -1;

    // Reset any cached data for current assessment
    wlData = undefined;
    isNewAssessment = undefined;
  }

  function collectAnsweredValuesInfoAndParticipants() {
    // 1) Gather all the current form answers as before
    const formAnswers = {};
    Object.values(wlForms).forEach(form => {
      Object.entries(form.inputs).forEach(([fieldId, inputComp]) => {
        let domEls = document.getElementsByName(fieldId).length
          ? Array.from(document.getElementsByName(fieldId))
          : [document.getElementById(fieldId)].filter(Boolean);

        if (domEls.length > 1 && domEls.some(el => el.classList.contains('fullscreen'))) {
          // keep only the fullscreen ones
          const fsEls = domEls.filter(el => el.classList.contains('fullscreen'));
          // pick the last in document order (i.e. the one you most recently appended)
          domEls = [fsEls[fsEls.length - 1]];
        }

        if (!domEls.length || domEls.some(el => el.disabled)) return;
        const val = inputComp.getValue(undefined, true);
        if (val !== '' && val != null && val !== false) {
          formAnswers[fieldId] = val;
        }
      });
    });

    // 2) Pull every saved participant row
    const participants = Object.values(wlParticipants).map(p => ({
      participantName: p.values[0],
      participantRelationship: p.values[1],
    }));

    // 3) Pull every saved housemate row (with all its fields)
    const housemates = Object.values(wlHousemates).map(h => ({
      housemateName: h.name,
      housemateRelationship: h.relationship,
      housemateAge: h.age,
      housemateIsCaregiver: h.isCaregiver,
      housemateServicesOffered: h.servicesOffered,
      housemateReceivesCare: h.receivesCare,
      housemateServicesReceived: h.servicesReceived,
    }));

    // 4) Return a single object
    return {
      ...formAnswers,
      participants,
      housemates,
    };
  }

  function showSpinner(message) {
    // Tear down any existing spinner
    if (_wlSpinner) {
      _wlSpinner.removeElement();
      _wlSpinner = null;
    }

    // 1) Build a container
    const wrapper = document.createElement('div');
    wrapper.classList.add('pendingSavePopup', 'popup');

    // 2) Optionally, add a message
    const msgElem = document.createElement('h2');
    msgElem.classList.add('spinner__message');
    msgElem.textContent = message || 'Loading…';

    msgElem.style.setProperty('display', 'block', 'important');

    // 3) Instantiate the new Spinner and attach
    _wlSpinner = new Spinner({
      /* you can pass size/speed overrides */
    });
    wrapper.appendChild(_wlSpinner.spinnerWrap);

    // 4) Append message + spinner into your ACTIONCENTER
    overlay.show();
    DOM.ACTIONCENTER.appendChild(wrapper);
    wrapper.appendChild(msgElem);
  }

  function hideSpinner() {
    // Remove the popup wrapper, hide overlay
    const popup = document.querySelector('.pendingSavePopup');
    if (popup) {
      popup.remove();
      overlay.hide();
    }
    // Clean up internal instance
    if (_wlSpinner) {
      _wlSpinner.removeElement();
      _wlSpinner = null;
    }
  }

  /* Edit Mode Functionality for Waiting List Assessment */

  // Call this to enter edit mode
  function enterEditMode() {
    editMode = true;
    // Ensure we have a reference to the assessment wrapper
    if (!assessmentWrap) {
      assessmentWrap = document.querySelector('#assessmentWrap') || document.body;
    }

    // Inject highlight style if not present
    if (!document.getElementById('edit-mode-style')) {
      const style = document.createElement('style');
      style.id = 'edit-mode-style';
      style.textContent = `
      fieldset { transition: outline 0.2s; }
      .edit-hover-highlight { outline: 2px dashed #007bff; cursor: pointer; }
    `;
      document.head.appendChild(style);
    }

    // Attach hover and click handlers to each fieldset
    const fsets = assessmentWrap.querySelectorAll('fieldset');
    fsets.forEach(fs => {
      fs.addEventListener('mouseenter', onEditModeMouseEnter);
      fs.addEventListener('mouseleave', onEditModeMouseLeave);
      fs.addEventListener('click', onEditModeClick);
    });
  }

  // Call this to exit edit mode and clean up
  function exitEditMode() {
    const style = document.getElementById('edit-mode-style');
    if (style) style.remove();

    const fsets = assessmentWrap.querySelectorAll('fieldset');
    fsets.forEach(fs => {
      fs.removeEventListener('mouseenter', onEditModeMouseEnter);
      fs.removeEventListener('mouseleave', onEditModeMouseLeave);
      fs.removeEventListener('click', onEditModeClick);
      fs.classList.remove('edit-hover-highlight');
    });
  }

  // Highlight on hover
  function onEditModeMouseEnter(event) {
    event.currentTarget.classList.add('edit-hover-highlight');
  }

  // Remove highlight on leave
  function onEditModeMouseLeave(event) {
    event.currentTarget.classList.remove('edit-hover-highlight');
  }

  // Handle click: enable selected, disable others
  function onEditModeClick(event) {
    const selectedFs = event.currentTarget;
    // Derive the question ID from the clicked fieldset
    const inputEl = selectedFs.querySelector('[name]');
    if (inputEl && inputEl.name) {
      currentQuestionId = inputEl.name;
    }
    const fsets = assessmentWrap.querySelectorAll('fieldset');
    fsets.forEach(fs => {
      const inputs = fs.querySelectorAll('input, textarea, select, button');
      const disable = fs !== selectedFs;
      fs.disabled = false;
      inputs.forEach(inp => (inp.disabled = disable));
    });
    exitEditMode();
  }

  function collectApprovalAndAssessedNeeds() {
    // ─── 1) Pull values from the "Approval" form ───
    const approvalInputs = wlForms['approval']?.inputs || {};
    const ac = wlForms['approvalCont']?.inputs || {};
    // approvalStatus
    let approvalStatus = approvalInputs['approvalStatus']?.getValue();
    if (!approvalStatus) {
      approvalStatus = ac['approvalStatus']?.getValue() || null;
    }

    // reasonForDisapproval
    let reasonForDisapproval = approvalInputs['reasonForDisapproval']?.getValue();
    if (!reasonForDisapproval) {
      reasonForDisapproval = ac['reasonForDisapproval']?.getValue() || null;
    }

    // ─── 1b) Pull the "Waiver Requirement" radio group as a boolean ───
    // getValue() may return either the value ("yes"/"no") or the input id ending in "yes"/"no"
    const waiverRaw = approvalInputs['waiverRequirement']?.getValue() || null;
    const waiverRequirement = waiverRaw != null ? /yes$/.test(waiverRaw) || waiverRaw === 'yes' : null;

    // ─── 1a) (NEW) Pull the "Unmet Need" textarea if it exists ───
    let unmetNeed = null;
    const unmetField = approvalInputs['unmetNeed'];
    if (unmetField) {
      unmetNeed = unmetField.getValue() || null;
    }

    // ─── 2) Always grab "Assessed Needs" (wlNeeds) if it exists ───
    const assessedNeedsArray =
      typeof wlNeeds !== 'undefined'
        ? Object.values(wlNeeds).map(entry => {
            const [assessedNeed, alternativeResourceOrService, countyBoardFollowUpDate] = entry.values;
            return { assessedNeed, alternativeResourceOrService, countyBoardFollowUpDate };
          })
        : [];

    // ─── 3) Community-Based Assessed Needs ───
    const communityBasedArray =
      typeof wlCommunityBasedNeeds !== 'undefined'
        ? Object.values(wlCommunityBasedNeeds).map(entry => {
            const [assessedNeed, alternativeResourceOrService, countyBoardFollowUpDate] = entry.values;
            return { assessedNeed, alternativeResourceOrService, countyBoardFollowUpDate };
          })
        : [];

    // ─── 4) Immediate (Individual) Assessed Needs ───
    const individualNeedsArray =
      typeof wlIndividualNeeds !== 'undefined'
        ? Object.values(wlIndividualNeeds).map(entry => {
            const [assessedNeed, resourcesUsedUntilWaiver] = entry.values;
            return { assessedNeed, resourcesUsedUntilWaiver };
          })
        : [];

    // ─── 5) Resources Used (Until Waiver) ───
    const resourcesUsedArray =
      typeof wlResourcesUsed !== 'undefined'
        ? Object.values(wlResourcesUsed).map(entry => {
            const [assessedNeed, resourcesUsedUntilWaiverEnrollment, countyBoardFollowUpDate] = entry.values;
            return { assessedNeed, resourcesUsedUntilWaiverEnrollment, countyBoardFollowUpDate };
          })
        : [];

    // ─── 6) County Board Contacts ───
    const countyBoardContactsArray =
      typeof wlCountyBoardContacts !== 'undefined'
        ? Object.values(wlCountyBoardContacts).map(entry => {
            const [countyBoardContactName, title, telephoneNumber, emailAddress] = entry.values;
            return { countyBoardContactName, title, telephoneNumber, emailAddress };
          })
        : [];

    // ─── 7) Return everything ───
    return {
      approval: {
        approvalStatus,
        reasonForDisapproval,
        waiverRequirement,
        unmetNeed,
      },
      assessedNeeds: assessedNeedsArray,
      communityBasedAssessedNeeds: communityBasedArray,
      individualAssessedNeeds: individualNeedsArray,
      resourcesUsed: resourcesUsedArray,
      countyBoardContacts: countyBoardContactsArray,
    };
  }

  async function handleFinalize() {
      // 1) Fetch your conclusion data
      const response = await _UTIL.fetchData('WLACompleteAssessmentAPI', {
        token: $.session.Token,
        WLInfoID,
      });
      const finalizeData = response.WLACompleteAssessmentAPIResult;
      finalizeResult = finalizeData;

      // 2) Close the popups
      // Only hide if errorPopup is defined and attached to the document
      const errorPopup = document.querySelector('.popup[data-popup="true"]');
      if (errorPopup) {
        POPUP.hide(errorPopup);
      }

      const background = document.querySelector('.popup__background');
      if (background) {
        background.remove();
      }

      // Branch based on finalizeResult:
      if (finalizeResult === 'Alternative Resources') {
        // 1) Merge both "approval" + "assessedNeeds" definitions into `sections`
        Object.entries(approvalSectionAlternateResources).forEach(([secId, cfg]) => {
          sections[secId] = {
            name: cfg.name,
            enabled: true,
            formElements: cfg.formElements || [],
          };
        });

        // 2) Render each new section from approvalSectionAlternateResources
        Object.keys(approvalSectionAlternateResources).forEach(secId => {
          const cfg = approvalSectionAlternateResources[secId];

          // ─── Build TOC entry ───
          const tocP = _DOM.createElement('p', { class: ['section', secId] });
          tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
          tableOfContents.appendChild(tocP);
          tocLinks[secId] = tocP;

          // ─── Create section wrapper + header ───
          const sectionWrap = _DOM.createElement('div', { id: secId, class: ['wlPage', secId] });
          sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

          // ─── If this section has formElements, make and render its Form ───
          if (Array.isArray(cfg.formElements) && cfg.formElements.length) {
            wlForms[secId] = new Form({
              hideAllButtons: true,
              fields: cfg.formElements,
              formName: secId,
              waitingListFlag: true
            });
            wlForms[secId].renderTo(sectionWrap);
            wlForms[secId].onChange(onFormChange);
          }

          // ─── Special case: “assessedNeeds” section ───
          if (secId === 'assessedNeeds') {
            assessedNeedsTable.renderTo(sectionWrap);
            assessedNeedsForm.renderTo(sectionWrap);
            sectionWrap.classList.add('hiddenPage');
            sections.assessedNeeds.enabled = false;
            tocLinks.assessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'countyBoardInfo') {
            countyBoardTable.renderTo(sectionWrap);
            countyBoardForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.countyBoardInfo.enabled = false;
            tocLinks.countyBoardInfo.classList.add('hiddenPage');
          }

          // ─── Finally append to the page ───
          assessmentWrap.appendChild(sectionWrap);

          getConclusionButton.renderTo(assessmentWrap);

          // ─── Hide reasonForDisapproval until needed ───
          const reasonWrapper = document.getElementById('reasonForDisapproval').closest('.reasonForDisapproval');
          reasonWrapper.style.display = 'none';
        });
      } else if (finalizeResult === 'No Unmet Need') {
        // ─── ONLY render the “approval” form with Approval Status + Reason for Disapproval ───
        // We do NOT render “assessedNeeds” or any tables/fields for needs.
        // (We can reuse approvalSectionAlternateResources.approval.formElements here since it has exactly those two fields.)

        const secId = 'approval'; // same ID as in approvalSectionAlternateResources
        const cfg = approvalSectionAlternateResources[secId];

        // 1) Merge just the approval section into `sections`
        sections[secId] = {
          name: cfg.name,
          enabled: true,
          formElements: cfg.formElements.slice(), // [ {approvalStatus}, {reasonForDisapproval} ]
        };

        // 2) Build TOC entry for approval
        const tocP = _DOM.createElement('p', { class: ['section', secId] });
        tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
        tableOfContents.appendChild(tocP);
        tocLinks[secId] = tocP;

        // 3) Create section wrapper + header
        const sectionWrap = _DOM.createElement('div', { id: secId, class: ['wlPage', secId] });
        sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

        // 4) Instantiate and render the Form with only those two fields
        wlForms[secId] = new Form({
          hideAllButtons: true,
          fields: cfg.formElements,
          formName: secId,
          waitingListFlag: true
        });
        wlForms[secId].renderTo(sectionWrap);
        wlForms[secId].onChange(onFormChange);

        assessmentWrap.appendChild(sectionWrap);

        getConclusionButton.renderTo(assessmentWrap);

        // 5) Initially hide the reasonForDisapproval text field until the user selects “Not Approved”
        const reasonWrapper = document.getElementById('reasonForDisapproval').closest('.reasonForDisapproval');
        reasonWrapper.style.display = 'none';
      } else {
        // 1) Merge CurrentNeedsorImmediateNeeds into `sections`
        Object.entries(CurrentNeedsorImmediateNeeds).forEach(([secId, cfg]) => {
          sections[secId] = {
            name: cfg.name,
            enabled: true,
            formElements: Array.isArray(cfg.formElements) ? cfg.formElements : [],
          };
        });

        // 2) For each section‐ID, create TOC link + wrapper + Form + Table
        Object.keys(CurrentNeedsorImmediateNeeds).forEach(secId => {
          const cfg = CurrentNeedsorImmediateNeeds[secId];

          // ─── Build the TOC entry ───
          const tocP = _DOM.createElement('p', { class: ['section', secId] });
          tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
          tableOfContents.appendChild(tocP);
          tocLinks[secId] = tocP;

          // ─── Create section wrapper + header ───
          const sectionWrap = _DOM.createElement('div', {
            id: secId,
            class: ['wlPage', secId],
          });
          sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

          // ─── If there are any formElements, render that Form ───
          if (Array.isArray(cfg.formElements) && cfg.formElements.length) {
            wlForms[secId] = new Form({
              hideAllButtons: true,
              fields: cfg.formElements,
              formName: secId,
              waitingListFlag: true
            });
            wlForms[secId].renderTo(sectionWrap);
            wlForms[secId].onChange(onFormChange);
          }

          // ─── SPECIAL CASE: render the correct Table+Form for each secId ───
          if (secId === 'immediateAssessedNeeds') {
            assessedNeedsTable.renderTo(sectionWrap);
            assessedNeedsForm.renderTo(sectionWrap);

            // hide by default, if that was your intent
            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.immediateAssessedNeeds.enabled = false;
            tocLinks.immediateAssessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'communityBasedAssessedNeeds') {
            communityBasedAssessedNeedsTable.renderTo(sectionWrap);
            communityBasedAssessedNeedsForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.communityBasedAssessedNeeds.enabled = false;
            tocLinks.communityBasedAssessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'IndividualAssessedNeeds') {
            // your “Immediate Assessed Needs” table + form:
            IndividualAssessedNeedsTable.renderTo(sectionWrap);
            IndividualAssessedNeedsForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.IndividualAssessedNeeds.enabled = false;
            tocLinks.IndividualAssessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'resourcesUsed') {
            resourcesUsedTable.renderTo(sectionWrap);
            resourcesUsedForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.resourcesUsed.enabled = false;
            tocLinks.resourcesUsed.classList.add('hiddenPage');
          } else if (secId === 'countyBoardInfo') {
            countyBoardTable.renderTo(sectionWrap);
            countyBoardForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.countyBoardInfo.enabled = false;
            tocLinks.countyBoardInfo.classList.add('hiddenPage');
          }

          // ─── Finally, append sectionWrap to the main container ───
          assessmentWrap.appendChild(sectionWrap);

          getConclusionButton.renderTo(assessmentWrap);

          const toHide = [
            '.unmetNeed',
            '#immediateAssessedNeeds',
            '#communityBasedAssessedNeeds',
            '.approvalStatus',
            '.reasonForDisapproval',
            '#alternativeResources',
            '#getConclusionBtn',
          ];

          toHide.forEach(selector => {
            const el = document.querySelector(selector);
            if (!el) return;
            // If it's a wrapper with a class, hide by style.display; if a section id, add hiddenPage:
            if (selector.startsWith('.')) {
              el.style.display = 'none';
            } else {
              el.classList.add('hiddenPage');
            }
          });
        });
      }
  }

  // DATA
  //--------------------------------------------------
  async function saveDocument(attachDetails) {
    const resp = await _UTIL.fetchData('addWlSupportingDocument', {
      waitingListInformationId: wlLinkID,
      description: attachDetails.description,
      includeOnEmail: data['email'] === 'on' ? 'Y' : 'N',
      attachmentType: attachDetails.type,
      attachment: attachDetails.attachment,
    });
    return resp.addWLSupportingDocumentResult[0].supportingDocumentId;
  }

  function updateGetConclusionButtonState() {
    const btn = document.getElementById('getConclusionBtn');
    let ready = true;
  
    if (finalizeResult === 'Alternative Resources') {
      Object.entries(approvalSectionAlternateResources).forEach(([secId, cfg]) => {
        const wrap = document.getElementById(secId);
        if (!wrap || wrap.classList.contains('hiddenPage')) return;
        (cfg.formElements || []).forEach(fe => {
          const inputEl = document.getElementById(fe.id);
          if (!inputEl) return;
          // skip if this question is hidden via CSS
          const questionWrapper = inputEl.closest('.inputGroup');
          if (questionWrapper && window.getComputedStyle(questionWrapper).display === 'none') {
            return;
          }
          const val = wlForms[secId].inputs[fe.id]?.getValue();
          if (!val) ready = false;
        });
      });

      const tables = [
        'assessedNeeds'
      ];
      
      for (const secId of tables) {
        const tblWrap = document.getElementById(secId);
        if (!tblWrap || tblWrap.classList.contains('hiddenPage')) {
          continue;  // skip hidden or missing sections
        }
      
        // find all <tr> inside the first <tbody> under this wrapper
        const rows = tblWrap.querySelectorAll('tbody tr');
        if (rows.length === 0) {
          ready = false;
          break;  // no rows → fail early
        }
      }
  
    } else if (finalizeResult === 'No Unmet Need') {
      Object.entries(approvalSectionAlternateResources).forEach(([secId, cfg]) => {
        const wrap = document.getElementById(secId);
        if (!wrap || wrap.classList.contains('hiddenPage')) return;
        (cfg.formElements || []).forEach(fe => {
          const inputEl = document.getElementById(fe.id);
          if (!inputEl) return;
          // skip if this question is hidden via CSS
          const questionWrapper = inputEl.closest('.inputGroup');
          if (questionWrapper && window.getComputedStyle(questionWrapper).display === 'none') {
            return;
          }
          const val = wlForms[secId].inputs[fe.id]?.getValue();
          if (!val) ready = false;
        });
      });
    } else if (finalizeResult === 'Immediate Need' ||
               finalizeResult === 'Current Need') {
      Object.entries(CurrentNeedsorImmediateNeeds).forEach(([secId, cfg]) => {
        const wrap = document.getElementById(secId);
        if (!wrap || wrap.classList.contains('hiddenPage')) return;
  
        // (1) questions
        (cfg.formElements || []).forEach(fe => {
          const inputEl = document.getElementById(fe.id);
          if (!inputEl) return;
      
          // find its question wrapper (adjust selector if yours is different)
          const questionWrapper = inputEl.closest('.inputGroup');
          if (!questionWrapper) return;
      
          // skip if hidden via CSS
          if (window.getComputedStyle(questionWrapper).display === 'none') {
            return;
          }
          const val = wlForms[secId].inputs[fe.id]?.getValue();
          if (!val) ready = false;
        });
  
        // (2) at least one row in any visible table
        const tables = [
          'immediateAssessedNeeds',
          'communityBasedAssessedNeeds',
          'IndividualAssessedNeeds',
          'resourcesUsed',
          'countyBoardInfo'
        ];
        
        for (const secId of tables) {
          const tblWrap = document.getElementById(secId);
          if (!tblWrap || tblWrap.classList.contains('hiddenPage')) {
            continue;  // skip hidden or missing sections
          }
        
          // find all <tr> inside the first <tbody> under this wrapper
          const rows = tblWrap.querySelectorAll('tbody tr');
          if (rows.length === 0) {
            ready = false;
            break;  // no rows → fail early
          }
        }
      });
  
    } else {
      // unexpected finalizeResult → disable
      ready = false;
    }
  
    getConclusionButton.toggleDisabled(!ready);
  }
  
  const onChangeCallbacks = {
    //* waitingListInfo
    currentLivingArrangement: async ({ value }) => {
      wlForms['waitingListInfo'].inputs['livingArrangementOther'].toggleDisabled(value !== 'Other');

      // … your existing show/hide for the table & form …
      const shouldShow = ['Lives with One Or More Other Persons In A Private Residence'].includes(value);

      // 1) flip the master flag
      sections.housemates.enabled = shouldShow;

      // 2) re‐toggle both TOC link and page wrapper
      tocLinks.housemates.classList.toggle('hiddenPage', !shouldShow);
      document.getElementById('housemates').classList.toggle('hiddenPage', !shouldShow);
    },
    approvalStatus: async ({ value }) => {
      const isApproved = value === 'Approved';

      setCountyBoardEnabled('approvalStatus', isApproved);

      if (finalizeResult === 'Alternative Resources') {
        // Toggle the assessedNeeds & countyBoardInfo “master‐switch” in `sections`:
        sections.assessedNeeds.enabled = isApproved;

        // Toggle its TOC entry’s hiddenPage class:
        tocLinks.assessedNeeds.classList.toggle('hiddenPage', !isApproved);

        // Toggle the wrapper’s .hiddenPage class (so it appears/disappears):
        document.getElementById('assessedNeeds').classList.toggle('hiddenPage', !isApproved);

        if (isApproved) {
          wlNeeds = {};
        }

        const reasonWrapper = document.querySelector('.reasonForDisapproval');
        if (value === 'Not Approved') {
          // Show “Reason For Disapproval” if they pick Not Approved
          if (reasonWrapper) reasonWrapper.style.display = '';
          wlForms['approval'].inputs['reasonForDisapproval'].setValue('Reassessment');
        } else {
          // Hide it (and clear any previous selection) if they pick Approved or clear the field
          if (reasonWrapper) {
            reasonWrapper.style.display = 'none';
            wlForms['approval'].inputs['reasonForDisapproval']?.setValue('');
          }
        }
      } else {
        const reasonWrapper = document.querySelector('.reasonForDisapproval');
        if (value === 'Not Approved') {
          // Show “Reason For Disapproval” if they pick Not Approved
          if (reasonWrapper) reasonWrapper.style.display = '';

          if (finalizeResult === 'No Unmet Need') {
            wlForms['approval'].inputs['reasonForDisapproval'].setValue('Reassessment');
          }
        } else {
          // Hide it (and clear any previous selection) if they pick Approved or clear the field
          if (reasonWrapper) {
            reasonWrapper.style.display = 'none';
            wlForms['approval'].inputs['reasonForDisapproval']?.setValue('');
          }

          if (finalizeResult !== 'No Unmet Need') {
            sections.immediateAssessedNeeds.enabled = isApproved;
            tocLinks.immediateAssessedNeeds.classList.toggle('hiddenPage', true);
            document.getElementById('immediateAssessedNeeds').classList.toggle('hiddenPage', true);
            if (isApproved) {
              wlNeeds = {};
            }
          }
        }
      }
    },

    waiverRequirement: async ({ value }) => {
      const isYes = value === 'yes';

      setCountyBoardEnabled('waiverRequirement', isYes);

      // All Finalize Results toggle the county board grid
      if (finalizeResult !== 'Immediate Need' && finalizeResult !== 'Current Need') return;

      // Toggle the “Unmet Need” textarea (only when yes)
      const unmetWrapper = document.querySelector('.unmetNeed');
      if (unmetWrapper) {
        unmetWrapper.style.display = isYes ? '' : 'none';
      }

      // Toggle the “Individual Assessed Needs” section (only when yes)
      const individualSection = document.getElementById('IndividualAssessedNeeds');
      if (individualSection) {
        individualSection.classList.toggle('hiddenPage', !isYes);
      }

      // Toggle the “Community Based Assessed Needs” section (only when no)
      const communitySection = document.getElementById('communityBasedAssessedNeeds');
      if (communitySection) {
        communitySection.classList.toggle('hiddenPage', isYes);
      }      

      // Show the Approval Status question in every case
      const approvalStatusWrapper = document.querySelector('.approvalStatus');
      if (approvalStatusWrapper) {
        approvalStatusWrapper.style.display = '';
      }

      // Clear out data for the branch they didn’t pick
      if (isYes) {
        // Clear “No” branch data: community-based grid and county board info
        wlCommunityBasedNeeds = {};
        wlCountyBoardContacts = {};
        const commTbody = document.querySelector('#communityBasedAssessedNeeds tbody');
        if (commTbody) commTbody.innerHTML = '';
        // (Clear any inputs in countyBoardInfo if needed)
      } else {
        // Clear “Yes” branch data: unmetNeed textarea & individual grid
        wlForms['approval'].inputs['unmetNeed']?.setValue('');
        wlIndividualNeeds = {};
        const indivTbody = document.querySelector('#IndividualAssessedNeeds tbody');
        if (indivTbody) indivTbody.innerHTML = '';
      }

      // Hide “Reason For Disapproval” (reset for next step)
      const reasonWrapper = document.querySelector('.reasonForDisapproval');
      if (reasonWrapper) {
        reasonWrapper.style.display = 'none';
        wlForms['approval'].inputs['reasonForDisapproval']?.setValue('');
      }

      // Hide “GET CONCLUSION” until further validation
      const btn = document.getElementById('getConclusionBtn');
      if (btn) btn.style.display = 'none';
    },

    reasonForDisapproval: async ({ value }) => {
      if (finalizeResult !== 'Immediate Need' && finalizeResult !== 'Current Need') return;

      // 1) Show the “Immediate Assessed Needs” section when “Alternative Resources” is chosen
      const immediateSection = document.getElementById('immediateAssessedNeeds');
      if (immediateSection) {
        if (value === 'Alternative resources') {
          immediateSection.classList.remove('hiddenPage');
        } else {
          immediateSection.classList.add('hiddenPage');
          wlNeeds = {};
        }
      }

      // 2) (Optional) Reset any rows in that section if they switch away from “Alternative Resources”
      if (value !== 'Alternative resources') {
        wlNeeds = {};
        const immediateTbody = document.querySelector('#immediateAssessedNeeds tbody');
        if (immediateTbody) immediateTbody.innerHTML = '';
      }

      // 3) Keep GET CONCLUSION hidden until at least one row is added to “Immediate Assessed Needs”
      const btn = document.getElementById('getConclusionBtn');
      if (btn) btn.style.display = 'none';
    },

    housemateIsCaregiver: async ({ value }) => {
      housematesForm.inputs['housemateServicesOffered'].toggleDisabled(value !== 'yes');
      if (value !== 'yes') {
        housematesForm.inputs['housemateServicesOffered'].setValue('');
      }
    },
    housemateReceivesCare: async ({ value }) => {
      housematesForm.inputs['housemateServicesReceived'].toggleDisabled(value !== 'yes');
      if (value !== 'yes') {
        housematesForm.inputs['housemateServicesReceived'].setValue('');
      }
    },
    isOtherService: async ({ value }) => {
      wlForms['currentAvailableServices'].inputs['otherDescription'].toggleDisabled(value === 'yes' ? false : true);
    },
  };
  async function onFormChange(event) {
    const type = event.target.type;
    const name = event.target.name;
    const id = event.target.id;
    const formName = event.target.form.name;
    let value = event.target.value;
    let checkboxGroupId;

    const sectionId = event.target.form.name;
    const qId = currentQuestionId;
    const formInst = wlForms[sectionId];

    if (formInst && sections[sectionId]) {
      const fe = sections[sectionId].formElements.find(f => f.id === qId);
      if (fe?.questionJSON) {
        // grab the Form API’s value for this field (works for text, radio groups, etc.)
        try {
          const newVal = formInst.inputs[qId].getValue();
          fe.questionJSON.response = newVal;
        } catch (e) {
          console.log(`Could not set response for ${qId}:`, e);
        }
      }
    }

    const entry = questionMap[currentQuestionId];
    if (entry) {
      entry.json.response = entry.form.inputs[currentQuestionId].getValue();
    }

    if (type === 'checkbox') {
      value = event.target.checked ? 'on' : 'off';
      checkboxGroupId = event.target.closest('fieldset')?.id;
    }

    if (onChangeCallbacks[name]) {
      await onChangeCallbacks[name]({ value, name });
    }

    if (onChangeCallbacks[checkboxGroupId]) {
      await onChangeCallbacks[checkboxGroupId]({ value, name });
    }

    toggleSendEmailDisabledStatus();
    updateNextQuestionButton();
    updateGetConclusionButtonState();
  }

  // MAIN
  //--------------------------------------------------
  function attachEvents() {
    sendEmailButton.onClick(async () => {
      sendEmailPopup.show();
    });
    sendEmailForm.onSubmit(async (data, submitter) => {
      let resp = await _UTIL.fetchData('generateWaitingListAssessmentReport', {
        waitingListId: wlLinkID,
      });
      resp = resp.generateWaitingListAssessmentReportResult;

      function checkIfReportIsReadyInterval(res) {
        // Get the interval in seconds from the session and convert it to milliseconds
        const intervalSeconds = parseInt($.session.reportSeconds);
        const intervalMilliseconds = intervalSeconds * 250;

        // Set up an interval to execute the checkIfReportExists function periodically
        const interval = setInterval(async () => {
          const reportExists = await checkIfReportExists(res);
          if (reportExists) {
            clearInterval(interval);
            const resp2 = await _UTIL.fetchData('sendWaitingListAssessmentReport', {
              header: data['emailHeader'],
              body: data['emailBody'],
              reportScheduleId: res,
              waitingListId: wlLinkID,
            });
          }
        }, intervalMilliseconds);
      }

      async function checkIfReportExists(res) {
        const data = {
          token: $.session.Token,
          reportScheduleId: res[0].reportScheduleId,
        };

        try {
          const response = await $.ajax({
            type: 'POST',
            url: `${$.webServer.protocol}://${$.webServer.address}:${$.webServer.port}/${$.webServer.serviceName}/checkIfReportExists/`,
            data: JSON.stringify(data),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
          });

          return response.checkIfReportExistsResult.indexOf('1') !== -1;
        } catch (error) {
          console.error('Error:', error);
          return false;
        }
      }

      checkIfReportIsReadyInterval(resp);

      sendEmailPopup.close();
    });
    sendEmailForm.onReset(() => {
      sendEmailPopup.close();
    });

    finalizeBtn.onClick(async () => {
      // 1) show the spinner
      showSpinner('Finalizing...');
    
      try {
        // 2) do the real work
        await handleFinalize();
      } finally {
        // 3) always hide it when done (or on error)
        hideSpinner();
      }
    });
    
    finalizePopupBtn.onClick(async () => {
      showSpinner('Finalizing...');
      try {
        await handleFinalize();
      } finally {
        hideSpinner();
      }
    });

      documentsButton.onClick(async () => {
        documentsPopup.show();
      });
    documentsForm.onSubmit(async (data, submitter, formId) => {
      const attachDetails = await _DOM.getAttachmentDetails(data['test']);

      const documentId = await saveDocument(attachDetails);

      const fileName = _UTIL.truncateFilename(attachDetails.description, 10);
      wlDocuments[documentId] = {
        id: documentId,
        values: [fileName, attachDetails.type],
      };

      addNewDocumentToList({ documentId, fileName });

      documentsForm.clear();
    });
    documentsForm.onReset(() => {
      documentsPopup.close();
    });

    assessedNeedsForm.onSubmit((data, submitter, formId) => {
      // If formId exists, we’re editing; otherwise insert new
      const id = formId || nextTempNeedId--;
      wlNeeds[id] = {
        id,
        // Store exactly what goes into each column
        values: [data.assessedNeed, data.alternativeResourceOrService, data.countyBoardFollowUpDate],
      };
      // Clear inputs so the form is ready for a new entry
      assessedNeedsForm.clear();
      // Rebuild the table from scratch
      assessedNeedsTable.populate(Object.values(wlNeeds));

      updateGetConclusionButtonState();
    });

    assessedNeedsTable.onRowClick(rowId => {
      // If your UI/permissions allow editing
      if (!$.session.waitingListUpdate) return;
      const rowData = wlNeeds[rowId];
      assessedNeedsForm.populate(
        {
          assessedNeed: rowData.values[0],
          alternativeResourceOrService: rowData.values[1],
          countyBoardFollowUpDate: rowData.values[2],
        },
        rowId,
      );
    });

    assessedNeedsTable.onRowDelete((row, rowId) => {
      if (!$.session.waitingListUpdate) return;
      delete wlNeeds[rowId];
      assessedNeedsTable.populate(Object.values(wlNeeds));
    });

    communityBasedAssessedNeedsForm.onSubmit((data, submitter, formId) => {
      // If formId exists, we’re editing; otherwise insert new
      const id = formId || nextTempCommunityId--;
      wlCommunityBasedNeeds[id] = {
        id,
        values: [data.assessedNeed, data.alternativeResourceOrService, data.countyBoardFollowUpDate],
      };

      // Clear inputs so the form is ready for a new entry
      communityBasedAssessedNeedsForm.clear();

      // Rebuild the table from scratch
      communityBasedAssessedNeedsTable.populate(Object.values(wlCommunityBasedNeeds));

      updateGetConclusionButtonState();
    });
    // :contentReference[oaicite:0]{index=0}

    // 2. Click-to-edit: populate the form when a row is clicked
    communityBasedAssessedNeedsTable.onRowClick(rowId => {
      // If your UI/permissions allow editing
      if (!$.session.waitingListUpdate) return;

      const rowData = wlCommunityBasedNeeds[rowId];
      communityBasedAssessedNeedsForm.populate(
        {
          assessedNeed: rowData.values[0],
          alternativeResourceOrService: rowData.values[1],
          countyBoardFollowUpDate: rowData.values[2],
        },
        rowId,
      );
    });

    // 3. Delete a row
    communityBasedAssessedNeedsTable.onRowDelete((row, rowId) => {
      if (!$.session.waitingListUpdate) return;
      delete wlCommunityBasedNeeds[rowId];
      communityBasedAssessedNeedsTable.populate(Object.values(wlCommunityBasedNeeds));
    });

    IndividualAssessedNeedsForm.onSubmit((data, submitter, formId) => {
      // If formId exists, we’re editing; otherwise insert new
      const id = formId || nextTempIndividualId--;
      wlIndividualNeeds[id] = {
        id,
        values: [data.currentAssessedNeed, data.resourcesUsedUntilWaiver],
      };

      // Clear the form for a fresh entry
      IndividualAssessedNeedsForm.clear();

      // Rebuild the table from scratch
      IndividualAssessedNeedsTable.populate(Object.values(wlIndividualNeeds));

      updateGetConclusionButtonState();
    });


    // 2. Click-to-edit: populate the form when a row is clicked
    IndividualAssessedNeedsTable.onRowClick(rowId => {
      if (!$.session.waitingListUpdate) return;

      const rowData = wlIndividualNeeds[rowId];
      IndividualAssessedNeedsForm.populate(
        {
          currentAssessedNeed: rowData.values[0],
          resourcesUsedUntilWaiver: rowData.values[1],
        },
        rowId,
      );
    });


    // 3. Delete a row
    IndividualAssessedNeedsTable.onRowDelete((row, rowId) => {
      if (!$.session.waitingListUpdate) return;
      delete wlIndividualNeeds[rowId];
      IndividualAssessedNeedsTable.populate(Object.values(wlIndividualNeeds));
    });

    resourcesUsedForm.onSubmit((data, submitter, formId) => {
      // If formId exists, we’re editing; otherwise insert new
      const id = formId || nextTempResourcesId--;
      wlResourcesUsed[id] = {
        id,
        values: [data.assessedNeedsForResources, data.resourcesUsedUntilWaiverEnrollment, data.countyBoardFollowUpDate],
      };

      // Clear form for next entry
      resourcesUsedForm.clear();

      // Rebuild the table from scratch
      resourcesUsedTable.populate(Object.values(wlResourcesUsed));

      updateGetConclusionButtonState();
    });


    // 2. Click-to-edit
    resourcesUsedTable.onRowClick(rowId => {
      if (!$.session.waitingListUpdate) return;

      const rowData = wlResourcesUsed[rowId];
      resourcesUsedForm.populate(
        {
          assessedNeedsForResources: rowData.values[0],
          resourcesUsedUntilWaiverEnrollment: rowData.values[1],
          countyBoardFollowUpDate: rowData.values[2],
        },
        rowId,
      );
    });


    // 3. Delete a row
    resourcesUsedTable.onRowDelete((row, rowId) => {
      if (!$.session.waitingListUpdate) return;
      delete wlResourcesUsed[rowId];
      resourcesUsedTable.populate(Object.values(wlResourcesUsed));
    });


    countyBoardForm.onSubmit((data, submitter, formId) => {
      // If formId exists, we’re editing; otherwise insert new
      const id = formId || nextTempCountyBoardId--;
      wlCountyBoardContacts[id] = {
        id,
        values: [
          data.countyBoardContactName,
          data.countyBoardTitle,
          data.countyBoardTelephoneNumber,
          data.countyBoardEmailAddress,
        ],
      };

      // Clear form
      countyBoardForm.clear();

      // Rebuild the table
      countyBoardTable.populate(Object.values(wlCountyBoardContacts));

      updateGetConclusionButtonState();
    });
    //

    // 2. Click-to-edit
    countyBoardTable.onRowClick(rowId => {
      if (!$.session.waitingListUpdate) return;

      const rowData = wlCountyBoardContacts[rowId];
      countyBoardForm.populate(
        {
          countyBoardContactName: rowData.values[0],
          countyBoardTitle: rowData.values[1],
          countyBoardTelephoneNumber: rowData.values[2],
          countyBoardEmailAddress: rowData.values[3],
        },
        rowId,
      );
    });
    //

    // 3. Delete a row
    countyBoardTable.onRowDelete((row, rowId) => {
      if (!$.session.waitingListUpdate) return;
      delete wlCountyBoardContacts[rowId];
      countyBoardTable.populate(Object.values(wlCountyBoardContacts));
    });
    //

    participantsForm.onSubmit(async (data, submitter, formId) => {
      const participantId = nextTempParticipantId--;

      wlParticipants[participantId] = {
        id: participantId,
        values: [data.participantName, data.participantRelationship],
      };

      // clear form
      participantsForm.clear();

      // repop table
      participantsTable.populate(Object.values(wlParticipants));

      tocLinks['participants'].classList.toggle('formComplete', Object.values(wlParticipants).length);
    });
    participantsTable.onRowClick(rowId => {
      if (!$.session.waitingListUpdate) return;

      const rowData = wlParticipants[rowId];
      participantsForm.populate(
        {
          participantName: rowData.values[0],
          participantRelationship: rowData.values[1],
        },
        rowId,
      );
    });
    participantsTable.onRowDelete(async (row, rowId) => {
      if (!$.session.waitingListUpdate) return;

      // await _UTIL.fetchData('deleteWaitingListParticipant', {
      //   participantId: parseInt(rowId),
      // });

      delete wlParticipants[rowId];

      participantsTable.populate(Object.values(wlParticipants));

      tocLinks['participants'].classList.toggle('formComplete', Object.values(wlParticipants).length);
    });

    // Save / Add Housemate
    housematesForm.onSubmit((data, submitter, formId) => {
      const id = formId || nextTempHousemateId--;
      wlHousemates[id] = {
        id,
        values: [data.housemateName, data.housemateRelationship],
        name: data.housemateName,
        relationship: data.housemateRelationship,
        age: data.housemateAge,
        isCaregiver: data.housemateIsCaregiver === 'yes',
        servicesOffered: data.housemateServicesOffered,
        receivesCare: data.housemateReceivesCare === 'yes',
        servicesReceived: data.housemateServicesReceived,
      };
      housematesForm.clear();
      housematesTable.populate(Object.values(wlHousemates));
    });

    // Click-to-edit
    housematesTable.onRowClick(rowId => {
      const h = wlHousemates[rowId];
      housematesForm.populate(
        {
          housemateName: h.name,
          housemateRelationship: h.relationship,
          housemateAge: h.age,
          housemateIsCaregiver: h.isCaregiver ? 'housemateIsCaregiveryes' : 'housemateIsCaregiverno',
          housemateServicesOffered: h.servicesOffered,
          housemateReceivesCare: h.receivesCare ? 'housemateReceivesCareyes' : 'housemateReceivesCareno',
          housemateServicesReceived: h.servicesReceived,
        },
        rowId,
      );
    });

    // Delete row
    housematesTable.onRowDelete((row, rowId) => {
      delete wlHousemates[rowId];
      housematesTable.populate(Object.values(wlHousemates));
    });

    backButton.onClick(async () => {
      resetSections();
      WaitingListOverview.init({ moduleHeader, moduleBody, selectedConsumer });
    });

    nextQuestionButton.onClick(async () => {
      // If only the 'Waiting List Information' and 'Pariticpants' sections are being sent, initiliaze the assessment first at DODD
      if (isNewAssessment) {
        await handleIsNewAssessmentFlow();
      } else {
        showSpinner('Saving Answer and Getting Next Question');

        if (!editMode) {
          await handleGetNextQuestionFlow();
        } else {
          handleEditModeNextQuestionFlow();
        }
      }
    });

    editAssessmentButton.onClick(() => {
      enterEditMode();
    });

    getConclusionButton.onClick(async () => {
      // 1) Collect inputs
      const {
        approval,
        assessedNeeds,
        communityBasedAssessedNeeds,
        individualAssessedNeeds,
        resourcesUsed,
        countyBoardContacts,
      } = collectApprovalAndAssessedNeeds();

      // 2) Build payload
      const payload = {
        WLInfoId: WLInfoID,
        SFAccountId,
        AssessmentId,
        finalizeResult,
        approvalStatus: approval.approvalStatus,
        reasonForDisapproval: approval.reasonForDisapproval,
        alternativeResources: assessedNeeds,
        communityBasedAlternativeResources: communityBasedAssessedNeeds,
        waiverEnrollmentRequired: approval.waiverRequirement,
        unmetNeed: approval.unmetNeed,
        individualAssessedUnmentNeed: individualAssessedNeeds,
        countyBoardInfo: countyBoardContacts,
      };

      try {
        showSpinner('Saving Approval + Assessed Needs');

        // 3) Send to backend
        const response = await _UTIL.fetchData('WLAApproveAssessment', payload);
        
        // 4) Hide spinner immediately
        hideSpinner();

        if (response) {
          let matchField;
          Object.entries(conlusionSection).forEach(([secId, cfg]) => {
            matchField = cfg.formElements[0].fields.find(c => c.label === response.WLAApproveAssessmentResult);
          })

          if (!matchField) {
            showErrorPopup('Get Conclusion Failed', response.WLAApproveAssessmentResult);
          }

          // ── Clear any existing conclusion sections ──
          Object.keys(conlusionSection).forEach(secId => {
            const wrap = document.getElementById(secId);
            if (wrap) {
              wrap.remove();
              tocLinks[secId]?.remove();
              delete sections[secId];
              delete wlForms[secId];
            }
          });

          // ── Merge & render the new conclusion sections ──
          Object.entries(conlusionSection).forEach(([secId, cfg]) => {
            // Update sections map
            sections[secId] = {
              name: cfg.name,
              enabled: true,
              formElements: cfg.formElements || [],
            };

            // TOC link
            const tocP = _DOM.createElement('p', { class: ['section', secId] });
            tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
            tableOfContents.appendChild(tocP);
            tocLinks[secId] = tocP;

            // Section wrapper + header
            const sectionWrap = _DOM.createElement('div', { id: secId, class: ['wlPage', secId] });
            sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

            // Form rendering
            if (Array.isArray(cfg.formElements) && cfg.formElements.length) {
              wlForms[secId] = new Form({
                hideAllButtons: true,
                fields: cfg.formElements,
                formName: secId,
                waitingListFlag: true
              });
              wlForms[secId].renderTo(sectionWrap);
              wlForms[secId].onChange(onFormChange);
            }

            if (matchField) {
              const input = sectionWrap.querySelector(`input[type="checkbox"]#${matchField.id}`);
              if (input) {
                input.checked = true;
                // fire a change so your Form’s onChange handler picks it up
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }

            // Append to main container
            assessmentWrap.appendChild(sectionWrap);

            // Hide edit and save buttons
            const editBtn = document.querySelector('.WLAEditAssessmentBtn');
            const saveNextBtn = document.querySelector('.WLANextQuestionBtn');
            const getConclusionBtn = document.querySelector('.WLAGetConclusionBtn');

            if (editBtn)     editBtn.style.display = 'none';
            if (saveNextBtn) saveNextBtn.style.display = 'none';
            if (getConclusionBtn) getConclusionBtn.style.display = 'none';
          });
        } else {
          // Failure case: show an error popup as before
          const errPopup = POPUP.build({ 
            header: 'Save Failed', 
            modal: true, 
            hideX: true, });
          const cancelBtn = button.build({
              type: 'button',
              style: 'secondary',
              text: 'Close',
              type: 'contained',
              callback: () => {
                POPUP.hide(errorPopup);
                document.querySelector('.popup__background')?.remove();
              }
          });

          const msg = document.createElement('p');
          msg.innerText = response.WLAApproveAssessmentResult;
          errPopup.appendChild(msg);
          errPopup.appendChild(cancelBtn);
          POPUP.show(errPopup);
        }
      } catch (err) {
        hideSpinner();
        const errorPopup = POPUP.build({ 
          header: 'Error', 
          modal: true, 
          hideX: true, });
        const cancelBtn = button.build({
          type: 'button',
          style: 'secondary',
          text: 'Close',
          type: 'contained',
          callback: () => {
            POPUP.hide(errorPopup);
            document.querySelector('.popup__background')?.remove();
          },
        });
        const msgPara = document.createElement('p');
        msgPara.innerText = err.message || 'An unexpected error occurred.';
        errorPopup.appendChild(msgPara);
        errorPopup.appendChild(cancelBtn);
        POPUP.show(errorPopup);
      }
    });
  }
  function loadPage() {
    // Header
    consumerCard.renderTo(moduleHeader);
    const primaryButtonWrap = _DOM.createElement('div');
    backButton.renderTo(primaryButtonWrap);
    if (SFAccountId === null || SFAccountId === '') {
      sendEmailButton.renderTo(primaryButtonWrap);
    }
    if (wlData?.readyForFinalization === true && wlData?.assessmentStatus !== 'Needs Approved') {
      finalizeBtn.renderTo(primaryButtonWrap);
    }
    documentsButton.renderTo(primaryButtonWrap);
    moduleHeader.appendChild(primaryButtonWrap);

    sendEmailForm.renderTo(sendEmailPopup.dialog);
    sendEmailPopup.renderTo(_DOM.ACTIONCENTER);

    doucmentsList = _DOM.createElement('div', { class: 'docList' });
    documentsPopup.dialog.appendChild(doucmentsList);
    documentsForm.renderTo(documentsPopup.dialog);
    documentsPopup.renderTo(_DOM.ACTIONCENTER);

    // Assessment
    for (section in sections) {
      const isContributingCircumstancesSubSection = [
        'needs',
        'primaryCaregiver',
        'riskMitigation',
        'icfDischarge',
        'intermittentSupports',
        'childProtectionAgency',
        'adultDayEmployment',
        'dischargePlan',
      ].includes(section);
      const isNeedsSubSection = ['behavioral', 'physical', 'medical', 'other'].includes(section);

      // Build TOC
      const className = isContributingCircumstancesSubSection || isNeedsSubSection ? 'subsection' : 'section';
      const tocSection = _DOM.createElement('p', { class: [className, section] });
      const tocSectionLink = _DOM.createElement('a', { href: `#${section}`, text: sections[section].name });
      //const statusIcon = Icon.getIcon('error');
      tocSection.appendChild(tocSectionLink);
      //tocSection.appendChild(statusIcon);
      tableOfContents.appendChild(tocSection);
      //tocSection.classList.toggle('hiddenPage', !sections[section].enabled);
      tocLinks[section] = tocSection;

      // Build Form
      const sectionWrap = _DOM.createElement('div', { id: section, class: 'wlPage' });
      const sectionHeader = _DOM.createElement('h2', {
        text: section === 'icfDischarge' ? 'ICF Discharge' : _UTIL.convertCamelCaseToTitle(section),
      });
      sectionWrap.appendChild(sectionHeader);
      //sectionWrap.classList.toggle('hiddenPage', !sections[section].enabled);

      if (section === 'housemates') {
        housematesTable.renderTo(sectionWrap);
        housematesForm.renderTo(sectionWrap);
        housematesForm.onChange(onFormChange);
        assessmentWrap.appendChild(sectionWrap);
        continue;
      }

      if (section === 'participants') {
        participantsTable.renderTo(sectionWrap);
        participantsForm.renderTo(sectionWrap);
        assessmentWrap.appendChild(sectionWrap);
        continue;
      }

      if (section === 'contributingCircumstances') {
        contributingCircumstancesWrap = sectionWrap;
        tocSection.classList.add('parent');
      }
      if (section === 'needs') {
        needsWrap = sectionWrap;
        tocSection.classList.add('parent');
      }

      if (sections[section].formElements) {
        wlForms[section] = new Form({
          hideAllButtons: true,
          fields: sections[section].formElements,
          formName: section,
          waitingListFlag: true
        });

        wlForms[section].renderTo(sectionWrap);
        wlForms[section].onChange(onFormChange);
      }

      if (isContributingCircumstancesSubSection) {
        contributingCircumstancesWrap.appendChild(sectionWrap);
      } else if (isNeedsSubSection) {
        needsWrap.appendChild(sectionWrap);
      } else {
        assessmentWrap.appendChild(sectionWrap);
      }
    }

    nextQuestionButton.renderTo(assessmentWrap);
  }
  function loadPageSkeleton() {
    moduleBody.innerHTML = '';
    moduleHeader.innerHTML = '';

    tableOfContents = _DOM.createElement('div', { class: 'waitingListTableOFContents' });
    assessmentWrap = _DOM.createElement('div', { class: 'waitingListAssessment' });

    moduleBody.appendChild(tableOfContents);
    moduleBody.appendChild(assessmentWrap);
  }

  // INIT (data & defaults)
  //--------------------------------------------------
  function initFormInfo() {
    return {
      waitingListInfo: { dbtable: 'WLA_Waiting_List_Information' },
      conditions: { dbtable: 'WLA_Conditions' },
      primaryCaregiver: { dbtable: 'WLA_Primary_Caregivers' },
      adultDayEmployment: { dbtable: 'WLA_Require_Waiver_Fundings' },
      childProtectionAgency: { dbtable: 'WLA_Child_Protection_Agencies' },
      currentAvailableServices: { dbtable: 'WLA_Active_Services' },
      currentNeeds: { dbtable: 'WLA_Unmet_Needs' },
      dischargePlan: { dbtable: 'WLA_Discharge_Plans' },
      icfDischarge: { dbtable: 'WLA_ICF_Discharges' },
      intermittentSupports: { dbtable: 'WLA_Intermitent_Supports' },
      immediateNeeds: { dbtable: 'WLA_Immediate_Needs' },
      riskMitigation: { dbtable: 'WLA_Risk_Mitigations' },
      waiverEnrollment: { dbtable: 'WLA_Waiver_Enrollments' },
      behavioral: { dbtable: 'WLA_Risks' },
      physical: { dbtable: 'WLA_Physical_Needs' },
      medical: { dbtable: 'WLA_Medical_Needs' },
      other: { dbtable: 'WLA_Needs' },
      conclusion: { dbtable: 'WLA_Waiting_List_Information' },
    };
  }
  function initComponents() {
    // Housemates
    housematesTable = new Table({
      columnSortable: true,
      allowDelete: true,
      headings: [
        { text: 'Name of Housemate', type: 'string' },
        { text: 'Relationship to Individual', type: 'string' },
      ],
    });
    housematesForm = new Form({
      fields: [
        { type: 'text', id: 'housemateName', label: 'Name of Housemate' },
        { type: 'text', id: 'housemateRelationship', label: 'Relationship to Individual' },
        { type: 'text', id: 'housemateAge', label: 'Age of Housemate' },
        {
          type: 'radiogroup',
          id: 'housemateIsCaregiver',
          groupLabel: 'Does housemate serve as unpaid or paid caregiver to the individual being assessed?',
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'housemateIsCaregiveryes' },
            { type: 'radio', label: 'No', value: 'no', id: 'housemateIsCaregiverno' },
          ],
        },
        {
          type: 'textarea',
          id: 'housemateServicesOffered',
          label: 'Describe Services Housemate Offers',
          fullscreen: true,
          disabled: true,
        },
        {
          type: 'radiogroup',
          id: 'housemateReceivesCare',
          groupLabel: 'Does housemate rely on services, supports, or care provided by another?',
          fields: [
            { type: 'radio', label: 'Yes', value: 'yes', id: 'housemateReceivesCareyes' },
            { type: 'radio', label: 'No', value: 'no', id: 'housemateReceivesCareno' },
          ],
        },
        {
          type: 'textarea',
          id: 'housemateServicesReceived',
          label: 'Describe Services Housemate Receives',
          fullscreen: true,
          disabled: true,
        },
      ],
      waitingListFlag: true
    });

    // Participants
    participantsTable = new Table({
      columnSortable: true,
      allowDelete: true,
      headings: [
        {
          text: 'Name of Participant',
          type: 'string',
        },
        {
          text: 'Relationship to Individual',
          type: 'string',
        },
      ],
    });
    participantsForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Name of Participant',
          id: 'participantName',
          //required: true,
        },
        {
          type: 'text',
          label: 'Relationship to Individual',
          id: 'participantRelationship',
          //required: true,
        },
      ],
      waitingListFlag: true
    });

    // Assessed Needs
    assessedNeedsTable = new Table({
      columnSortable: true,
      allowDelete: true,
      headings: [
        {
          text: 'Assessed Need',
          type: 'string',
        },
        {
          text: 'Alternative Resource or Service',
          type: 'string',
        },
        {
          text: 'County Board Follow-Up Date',
          type: 'date',
        },
      ],
    });
    assessedNeedsForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Assessed Need',
          id: 'assessedNeed',
          //required: true,
        },
        {
          type: 'text',
          label: 'Alternative Resource or Service',
          id: 'alternativeResourceOrService',
          //required: true,
        },
        {
          type: 'date',
          label: 'County Board Follow-Up Date',
          id: 'countyBoardFollowUpDate',
          //required: true,
        },
      ],
      waitingListFlag: true
    });

    // Community Based Assessed Needs
    communityBasedAssessedNeedsTable = new Table({
      columnSortable: true,
      allowDelete: true,
      headings: [
        {
          text: 'Assessed Need',
          type: 'string',
        },
        {
          text: 'Alternative Resource or Service',
          type: 'string',
        },
        {
          text: 'County Board Follow-Up Date',
          type: 'string',
        },
      ],
    });
    communityBasedAssessedNeedsForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Assessed Need',
          id: 'assessedNeed',
          //required: true,
        },
        {
          type: 'text',
          label: 'Alternative Resource or Service',
          id: 'alternativeResourceOrService',
          //required: true,
        },
        {
          type: 'date',
          label: 'County Board Follow-Up Date',
          id: 'countyBoardFollowUpDate',
          //required: true,
        },
      ],
      waitingListFlag: true
    });

    // Immediate Assesssed Needs
    IndividualAssessedNeedsTable = new Table({
      columnSortable: true,
      allowDelete: true,
      headings: [
        {
          text: 'Assessed Need',
          type: 'string',
        },
        {
          text: 'Resources Used Until Waiver Enrollment',
          type: 'string',
        },
      ],
    });
    IndividualAssessedNeedsForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Assessed Need',
          id: 'currentAssessedNeed',
          //required: true,
        },
        {
          type: 'text',
          label: 'Resources Used Until Waiver Enrollment',
          id: 'resourcesUsedUntilWaiver',
          //required: true,
        },
      ],
      waitingListFlag: true
    });

    // Resources Used
    resourcesUsedTable = new Table({
      columnSortable: true,
      allowDelete: true,
      headings: [
        {
          text: 'Assessed Need',
          type: 'string',
        },
        {
          text: 'Resources Used Until Waiver Enrollment',
          type: 'string',
        },
      ],
    });
    resourcesUsedForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Assessed Need',
          id: 'assessedNeedsForResources',
          //required: true,
        },
        {
          type: 'text',
          label: 'Resources Used Until Waiver Enrollment',
          id: 'resourcesUsedUntilWaiverEnrollment',
          //required: true,
        },
        {
          type: 'text',
          label: 'County Board Follow-Up Date',
          id: 'countyBoardFollowUpDate',
          //required: true,
        },
      ],
      waitingListFlag: true
    });

    // County Board
    countyBoardTable = new Table({
      columnSortable: true,
      allowDelete: true,
      headings: [
        {
          text: 'County Board Contact Name',
          type: 'string',
        },
        {
          text: 'Title',
          type: 'string',
        },
        {
          text: 'Telephone Number',
          type: 'string',
        },
        {
          text: 'Email Address',
          type: 'string',
        },
      ],
    });
    countyBoardForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'County Board Contact Name',
          id: 'countyBoardContactName',
          //required: true,
        },
        {
          type: 'text',
          label: 'Title',
          id: 'countyBoardTitle',
          //required: true,
        },
        {
          type: 'text',
          label: 'Telephone Number',
          id: 'countyBoardTelephoneNumber',
          //required: true,
        },
        {
          type: 'text',
          label: 'Email Address',
          id: 'countyBoardEmailAddress',
          //required: true,
        },
      ],
      waitingListFlag: true
    });

    // Reports
    sendEmailButton = new Button({
      text: 'Send Report',
      style: 'primary',
      styleType: 'contained',
      disabled: true,
    });
    sendEmailForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Email Header',
          id: 'emailHeader',
          value: 'Waiting List Assessment',
        },
        {
          type: 'text',
          label: 'Email Body',
          id: 'emailBody',
          value: `Waiting list assessment for ${selectedConsumer.firstName} ${selectedConsumer.middleName} ${selectedConsumer.lastName} attached`,
        },
      ],
      waitingListFlag: true
    });
    sendEmailPopup = new Dialog({ className: 'wlEmailPopup' });

    // Documents
    documentsButton = new Button({
      text: 'Add New Documentation',
      style: 'primary',
      styleType: 'contained',
      disabled: !$.session.waitingListUpdate,
    });
    documentsForm = new Form({
      fields: [
        { type: 'file', id: 'test', label: 'Document Upload' },
        { type: 'checkbox', id: 'email', label: 'Include in email?' },
      ],
      waitingListFlag: true
    });
    documentsPopup = new Dialog({ className: 'wlDocumentPopup' });

    // Back to overview
    backButton = new Button({
      text: 'Back',
      style: 'primary',
      styleType: 'outlined',
    });

    // Finalization
    finalizeBtn = new Button({
      text: 'Finalize',
      style: 'primary',
      styleType: 'contained',
    });

    finalizePopupBtn = new Button({
      text: 'Finalize Now',
      style: 'Secondary',
      styleType: 'contained',
      class: ['btn', 'btn--secondary']
    });

    // consumer card
    consumerCard = new RosterCard({
      consumerId: selectedConsumer.id,
      firstName: selectedConsumer.firstName,
      middleName: selectedConsumer.middleName,
      lastName: selectedConsumer.lastName,
      generation: selectedConsumer.generation,
    });

    nextQuestionButton = new Button({
      text: 'Save and go to next question',
      style: 'primary',
      styleType: 'contained',
      disabled: true,
      class: ['WLANextQuestionBtn'],
    });

    editAssessmentButton = new Button({
      text: 'Edit Assessment',
      style: 'primary',
      styleType: 'contained',
      class: ['WLAEditAssessmentBtn'],
    });

    getConclusionButton = new Button({
      text: 'Get Conclusion',
      style: 'primary',
      styleType: 'contained',
      class: ['WLAGetConclusionBtn'],
      disabled: true
    });
  }

  async function init(opts) {
    wlCircID = '';
    wlNeedID = '';
    wlForms = {};
    tocLinks = {};
    wlDocuments = [];
    wlParticipants = {};
    wlData = opts.wlData;
    wlFormInfo = initFormInfo();
    selectedConsumer = opts.selectedConsumer;
    moduleHeader = opts.moduleHeader;
    moduleBody = opts.moduleBody;
    WLInfoID = opts.WLInfoID;

    isNewAssessment = opts.isNewAssessment;
    isComplete = opts.isNewAssessment ? 'Draft' : opts.wlData.assessmentStatus;

    const response = await _UTIL.fetchData('getConsumerSalesforceId', { peopleId: selectedConsumer.id });
    SFAccountId = response.GetConsumerSalesforceIdResult;

    if ((SFAccountId === null || SFAccountId === '') && isNewAssessment === true) {
      const WarningPopup = POPUP.build({
        header: 'No Salesforce ID Found',
        modal: true,
        hideX: true,
      });

      const continueBtn = button.build({
        type: 'button',
        style: 'secondary',
        text: 'Continue',
        callback: () => {
          POPUP.hide(WarningPopup);

          const popupBg = document.querySelector('.popup__background');
          if (popupBg) {
            popupBg.remove(); // this will completely remove the div from the DOM
          }

          // Load the legacy waitingListAssessment Page
          WaitingListAssessment.init(opts)
        },
      });

      const cancelBtn = button.build({
        type: 'button',
        style: 'secondary',
        text: 'Cancel',
        type: 'contained',
        callback: () => {
          POPUP.hide(WarningPopup);

          const popupBg = document.querySelector('.popup__background');
          if (popupBg) {
            popupBg.remove(); // this will completely remove the div from the DOM
          }
        },
      });

      const msgParagraph = document.createElement('p');
      const popupText = 'This individual does not have a Salesforce ID.  If you continue you will NOT be able to send the assessment to DODD.  We strongly recommend that you wait until this individual has a Salesforce ID before completing the assessment';
      msgParagraph.innerHTML = popupText;

      const buttonWrapper =  document.createElement('div');

      buttonWrapper.style.cssText = 'margin-top: 5px; display: flex; justify-content: center; gap: 15px;';

      WarningPopup.appendChild(msgParagraph);
      WarningPopup.appendChild(buttonWrapper);
      buttonWrapper.appendChild(continueBtn)
      buttonWrapper.appendChild(cancelBtn);

      POPUP.show(WarningPopup);
      return;
    }

    loadPageSkeleton();
    initComponents();
    loadPage();
    attachEvents();

    if (!$.session.waitingListUpdate) {
      participantsForm.disableFormInputs(true);
    }

    tocLinks['participants'].classList.toggle('formComplete', Object.values(wlParticipants).length);

    // Grab the current living arrangement, or undefined if wlData/wlInfo doesn't exist
    const current = wlData?.wlInfo?.currentLivingArrangement;

    // Only these two values should show the housemates section
    const validArrangements = ['Lives with Family or Other Caregivers', 'Lives With Others Who Are Not Caregivers'];

    // If current is undefined (or anything else), includes() will be false
    const shouldShow = validArrangements.includes(current);

    // Toggle your UI
    sections.housemates.enabled = shouldShow;
    tocLinks.housemates.classList.toggle('hiddenPage', !shouldShow);
    document.getElementById('housemates').classList.toggle('hiddenPage', !shouldShow);

    // if we have existing data, render it all in one go
    if (!isNewAssessment && wlData) {
      finalizeResult = wlData.waitingListResult;
      AssessmentId = wlData.questions[0].AssessmentId;
      // 1) populate the top‐level form
      wlForms.waitingListInfo.populate(wlData.wlInfo);
      wlForms.currentAvailableServices.populate(wlData.currentAvailableServices);
      participantsTable.populate(Object.values(wlData.participants));
      housematesTable.populate(Object.values(wlData.housemates));

      // 2) for each question payload, call your render function
      wlData.questions.forEach(qJSON => addQuestionOrSection(qJSON));

      // Branch based on finalizeResult:
      if (finalizeResult === 'Alternative Resources') {
        // 1) Merge both "approval" + "assessedNeeds" definitions into `sections`
        Object.entries(approvalSectionAlternateResources).forEach(([secId, cfg]) => {
          sections[secId] = {
            name: cfg.name,
            enabled: true,
            formElements: cfg.formElements || [],
          };
        });

        // 2) Render each new section from approvalSectionAlternateResources
        Object.keys(approvalSectionAlternateResources).forEach(secId => {
          const cfg = approvalSectionAlternateResources[secId];

          // ─── Build TOC entry ───
          const tocP = _DOM.createElement('p', { class: ['section', secId] });
          tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
          tableOfContents.appendChild(tocP);
          tocLinks[secId] = tocP;

          // ─── Create section wrapper + header ───
          const sectionWrap = _DOM.createElement('div', { id: secId, class: ['wlPage', secId] });
          sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

          // ─── If this section has formElements, make and render its Form ───
          if (Array.isArray(cfg.formElements) && cfg.formElements.length) {
            wlForms[secId] = new Form({
              hideAllButtons: true,
              fields: cfg.formElements,
              formName: secId,
              waitingListFlag: true
            });
            wlForms[secId].renderTo(sectionWrap);
            wlForms[secId].onChange(onFormChange);
          }

          // ─── Special case: “assessedNeeds” section ───
          if (secId === 'assessedNeeds') {
            assessedNeedsTable.renderTo(sectionWrap);
            assessedNeedsForm.renderTo(sectionWrap);
            sectionWrap.classList.add('hiddenPage');
            sections.assessedNeeds.enabled = false;
            tocLinks.assessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'countyBoardInfo') {
            countyBoardTable.renderTo(sectionWrap);
            countyBoardForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.countyBoardInfo.enabled = false;
            tocLinks.countyBoardInfo.classList.add('hiddenPage');
          }

          wlForms.approval.populate({
            approvalStatus: wlData.assessmentStatus,
            reasonForDisapproval: wlData.reasonForDisapproval,
          });

          // ─── Finally append to the page ───
          assessmentWrap.appendChild(sectionWrap);

          getConclusionButton.renderTo(assessmentWrap);

          if (wlData.assessmentStatus === 'Needs Approved' || wlData.assessmentStatus === 'Approved') {
            // ─── Hide reasonForDisapproval until needed ───
            const reasonWrapper = document.getElementById('reasonForDisapproval').closest('.reasonForDisapproval');
            reasonWrapper.style.display = 'none';
          }

          if (wlData.assessmentStatus === 'Approved' && secId === 'assessedNeeds') {
            sectionWrap.classList.remove('hiddenPage');
            sections.assessedNeeds.enabled = true;
            tocLinks.assessedNeeds.classList.remove('hiddenPage');

            assessedNeedsTable.populate(Object.values(wlData.chart2));
          }
        });
      } else if (finalizeResult === 'No Unmet Need') {
        // ─── ONLY render the “approval” form with Approval Status + Reason for Disapproval ───
        // We do NOT render “assessedNeeds” or any tables/fields for needs.
        // (We can reuse approvalSectionAlternateResources.approval.formElements here since it has exactly those two fields.)

        const secId = 'approval'; // same ID as in approvalSectionAlternateResources
        const cfg = approvalSectionAlternateResources[secId];

        // 1) Merge just the approval section into `sections`
        sections[secId] = {
          name: cfg.name,
          enabled: true,
          formElements: cfg.formElements.slice(), // [ {approvalStatus}, {reasonForDisapproval} ]
        };

        // 2) Build TOC entry for approval
        const tocP = _DOM.createElement('p', { class: ['section', secId] });
        tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
        tableOfContents.appendChild(tocP);
        tocLinks[secId] = tocP;

        // 3) Create section wrapper + header
        const sectionWrap = _DOM.createElement('div', { id: secId, class: ['wlPage', secId] });
        sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

        // 4) Instantiate and render the Form with only those two fields
        wlForms[secId] = new Form({
          hideAllButtons: true,
          fields: cfg.formElements,
          formName: secId,
          waitingListFlag: true
        });
        wlForms[secId].renderTo(sectionWrap);
        wlForms[secId].onChange(onFormChange);

        assessmentWrap.appendChild(sectionWrap);

        getConclusionButton.renderTo(assessmentWrap);

        wlForms['approval'].populate({
          approvalStatus: wlData.assessmentStatus,
          reasonForDisapproval: wlData.reasonForDisapproval,
        });

        if (wlData.assessmentStatus === 'Needs Approved' || wlData.assessmentStatus === 'Approved') {
          // ─── Hide reasonForDisapproval until needed ───
          const reasonWrapper = document.getElementById('reasonForDisapproval').closest('.reasonForDisapproval');
          reasonWrapper.style.display = 'none';
        }
      } else if (finalizeResult === 'Immediate Need' || finalizeResult === 'Current Need') {
        // 1) Merge CurrentNeedsorImmediateNeeds into `sections`
        Object.entries(CurrentNeedsorImmediateNeeds).forEach(([secId, cfg]) => {
          sections[secId] = {
            name: cfg.name,
            enabled: true,
            formElements: Array.isArray(cfg.formElements) ? cfg.formElements : [],
          };
        });

        // 2) For each section‐ID, create TOC link + wrapper + Form + Table
        Object.keys(CurrentNeedsorImmediateNeeds).forEach(secId => {
          const cfg = CurrentNeedsorImmediateNeeds[secId];

          // ─── Build the TOC entry ───
          const tocP = _DOM.createElement('p', { class: ['section', secId] });
          tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
          tableOfContents.appendChild(tocP);
          tocLinks[secId] = tocP;

          // ─── Create section wrapper + header ───
          const sectionWrap = _DOM.createElement('div', {
            id: secId,
            class: ['wlPage', secId],
          });
          sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

          // ─── If there are any formElements, render that Form ───
          if (Array.isArray(cfg.formElements) && cfg.formElements.length) {
            wlForms[secId] = new Form({
              hideAllButtons: true,
              fields: cfg.formElements,
              formName: secId,
              waitingListFlag: true
            });
            wlForms[secId].renderTo(sectionWrap);
            wlForms[secId].onChange(onFormChange);
          }

          // ─── SPECIAL CASE: render the correct Table+Form for each secId ───
          if (secId === 'immediateAssessedNeeds') {
            assessedNeedsTable.renderTo(sectionWrap);
            assessedNeedsForm.renderTo(sectionWrap);

            // hide by default, if that was your intent
            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.immediateAssessedNeeds.enabled = false;
            tocLinks.immediateAssessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'communityBasedAssessedNeeds') {
            communityBasedAssessedNeedsTable.renderTo(sectionWrap);
            communityBasedAssessedNeedsForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.communityBasedAssessedNeeds.enabled = false;
            tocLinks.communityBasedAssessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'IndividualAssessedNeeds') {
            // your “Immediate Assessed Needs” table + form:
            IndividualAssessedNeedsTable.renderTo(sectionWrap);
            IndividualAssessedNeedsForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.IndividualAssessedNeeds.enabled = false;
            tocLinks.IndividualAssessedNeeds.classList.add('hiddenPage');
          } else if (secId === 'resourcesUsed') {
            resourcesUsedTable.renderTo(sectionWrap);
            resourcesUsedForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.resourcesUsed.enabled = false;
            tocLinks.resourcesUsed.classList.add('hiddenPage');
          } else if (secId === 'countyBoardInfo') {
            countyBoardTable.renderTo(sectionWrap);
            countyBoardForm.renderTo(sectionWrap);

            sectionWrap.classList.add('hiddenPage');
            CurrentNeedsorImmediateNeeds.countyBoardInfo.enabled = false;
            tocLinks.countyBoardInfo.classList.add('hiddenPage');
          }

          // ─── Finally, append sectionWrap to the main container ───
          assessmentWrap.appendChild(sectionWrap);

          if (wlData.waiverRequired === '0' && secId === 'communityBasedAssessedNeeds') {
            sectionWrap.classList.remove('hiddenPage');
            sections.communityBasedAssessedNeeds.enabled = true;
            tocLinks.communityBasedAssessedNeeds.classList.remove('hiddenPage');

            communityBasedAssessedNeedsTable.populate(Object.values(wlData.chart4));
          }

          if (wlData.waiverRequired === '0' && secId === 'countyBoardInfo') {
            sectionWrap.classList.remove('hiddenPage');
            sections.countyBoardInfo.enabled = true;
            tocLinks.countyBoardInfo.classList.remove('hiddenPage');

            countyBoardTable.populate(Object.values(wlData.chart3));
          }

          if (wlData.waiverRequired === '1' && secId === 'individualAssessedNeeds') {
            sectionWrap.classList.remove('hiddenPage');
            sections.individualAssessedNeeds.enabled = true;
            tocLinks.individualAssessedNeeds.classList.remove('hiddenPage');

            IndividualAssessedNeedsTable.populate(Object.values(wlData.chart3));
          }

          if (wlData.reasonForDisapproval === 'Alternative resources' && secId === 'immediateAssessedNeeds') {
            sectionWrap.classList.remove('hiddenPage');
            sections.immediateAssessedNeeds.enabled = true;
            tocLinks.immediateAssessedNeeds.classList.remove('hiddenPage');

            assessedNeedsTable.populate(Object.values(wlData.chart3));
          }
        });

        wlForms['approval'].populate({
          waiverRequirement:
            wlData.waiverRequired === '0'
              ? 'isWaiverRequiredno'
              : wlData.waiverRequired === '1'
              ? 'isWaiverRequiredyes'
              : null,
          unmetNeed: wlData.unmetNeeds,
        });

        wlForms['approvalCont'].populate({
          approvalStatus: wlData.assessmentStatus,
          reasonForDisapproval: wlData.reasonForDisapproval,
        });

        if (wlData.assessmentStatus === 'Needs Approved' || wlData.assessmentStatus === 'Approved') {
          // ─── Hide reasonForDisapproval until needed ───
          const reasonWrapper = document.getElementById('reasonForDisapproval').closest('.reasonForDisapproval');
          reasonWrapper.style.display = 'none';
        }

        if (wlData.assessmentStatus === 'Needs Approved' || wlData.waiverRequired === "") {
          const approvalStatusWrapper = document.getElementById('approvalStatus').closest('.approvalStatus');
          approvalStatusWrapper.style.display = 'none';
        }

        if (wlData.assessmentStatus === 'Needs Approved' || wlData.waiverRequired === '0') {
          // ─── Hide reasonForDisapproval until needed ───
          const unmetNeedsWrapper = document.getElementById('unmetNeed').closest('.unmetNeed');
          unmetNeedsWrapper.style.display = 'none';
        }
      }

      if (wlData.assessmentStatus === 'Approved' || wlData.assessmentStatus === 'Not Approved') {
        Object.keys(conlusionSection).forEach(secId => {
          const wrap = document.getElementById(secId);
          if (wrap) {
            wrap.remove();
            tocLinks[secId]?.remove();
            delete sections[secId];
            delete wlForms[secId];
          }
        });

        // ── Merge & render the new conclusion sections ──
        Object.entries(conlusionSection).forEach(([secId, cfg]) => {
          // Update sections map
          sections[secId] = {
            name: cfg.name,
            enabled: true,
            formElements: cfg.formElements || [],
          };

          // TOC link
          const tocP = _DOM.createElement('p', { class: ['section', secId] });
          tocP.appendChild(_DOM.createElement('a', { href: `#${secId}`, text: cfg.name }));
          tableOfContents.appendChild(tocP);
          tocLinks[secId] = tocP;

          // Section wrapper + header
          const sectionWrap = _DOM.createElement('div', { id: secId, class: ['wlPage', secId] });
          sectionWrap.appendChild(_DOM.createElement('h2', { text: cfg.name }));

          // Form rendering
          if (Array.isArray(cfg.formElements) && cfg.formElements.length) {
            wlForms[secId] = new Form({
              hideAllButtons: true,
              fields: cfg.formElements,
              formName: secId,
              waitingListFlag: true
            });
            wlForms[secId].renderTo(sectionWrap);
            wlForms[secId].onChange(onFormChange);
          }

          const selectedIndex = parseInt(wlData.conclusionResult, 10);

          // grab the nth option from your formElements
          const fieldCfg = cfg.formElements[0].fields[selectedIndex];
          if (fieldCfg) {
            // find the corresponding checkbox by its id
            const input = sectionWrap.querySelector(`input[type="checkbox"]#${fieldCfg.id}`);
            if (input) {
              input.checked = true;
              // trigger your Form onChange logic
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          // Append to main container
          assessmentWrap.appendChild(sectionWrap);
        });
      }

      if (wlData.assessmentStatus === 'Needs Approved') {
        getConclusionButton.renderTo(assessmentWrap);
      }

      if (wlData.assessmentStatus === 'Draft') {
        editAssessmentButton.renderTo(assessmentWrap);
      }

      // 3) make sure anything answered is disabled
      disableAnsweredQuestions();
    }

    toggleSendEmailDisabledStatus();
    updateNextQuestionButton();

    const docResp = await _UTIL.fetchData('getWLSupportingDocumentList', { waitingListInformationId: wlLinkID });
    for (const doc of docResp.getWLSupportingDocumentListResult) {
      const fileName = _UTIL.truncateFilename(doc.description, 10);
      wlDocuments[doc.supportingDocumentId] = {
        id: doc.supportingDocumentId,
        values: [fileName, doc.type],
      };

      addNewDocumentToList({ documentId: doc.supportingDocumentId, fileName });
    }
  }

  return { init, unload };
})();
